/**
 * Fardriver Tuner - Bundled for Shopify Voltalize theme
 * Protocol + BLE + App in a single IIFE
 * v2 - fixed residual ES import
 */
(function() {
"use strict";

/**
 * Fardriver Controller Protocol Implementation
 * Based on https://github.com/jackhumbert/fardriver-controllers
 *
 * Packet structure (16 bytes receiving):
 * [0xAA] [id:6|flags:2] [data x 12] [CRC_hi] [CRC_lo]
 *
 * flags=2: receiving status updates
 * id < 0x37: lookup address in flash_read_addr table
 */

// Standard Modbus CRC-16 lookup tables
const crcTableHi = [
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40, 0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41,
    0x00, 0xC1, 0x81, 0x40, 0x01, 0xC0, 0x80, 0x41, 0x01, 0xC0, 0x80, 0x41, 0x00, 0xC1, 0x81, 0x40
];

const crcTableLo = [
    0x00, 0xC0, 0xC1, 0x01, 0xC3, 0x03, 0x02, 0xC2, 0xC6, 0x06, 0x07, 0xC7, 0x05, 0xC5, 0xC4, 0x04,
    0xCC, 0x0C, 0x0D, 0xCD, 0x0F, 0xCF, 0xCE, 0x0E, 0x0A, 0xCA, 0xCB, 0x0B, 0xC9, 0x09, 0x08, 0xC8,
    0xD8, 0x18, 0x19, 0xD9, 0x1B, 0xDB, 0xDA, 0x1A, 0x1E, 0xDE, 0xDF, 0x1F, 0xDD, 0x1D, 0x1C, 0xDC,
    0x14, 0xD4, 0xD5, 0x15, 0xD7, 0x17, 0x16, 0xD6, 0xD2, 0x12, 0x13, 0xD3, 0x11, 0xD1, 0xD0, 0x10,
    0xF0, 0x30, 0x31, 0xF1, 0x33, 0xF3, 0xF2, 0x32, 0x36, 0xF6, 0xF7, 0x37, 0xF5, 0x35, 0x34, 0xF4,
    0x3C, 0xFC, 0xFD, 0x3D, 0xFF, 0x3F, 0x3E, 0xFE, 0xFA, 0x3A, 0x3B, 0xFB, 0x39, 0xF9, 0xF8, 0x38,
    0x28, 0xE8, 0xE9, 0x29, 0xEB, 0x2B, 0x2A, 0xEA, 0xEE, 0x2E, 0x2F, 0xEF, 0x2D, 0xED, 0xEC, 0x2C,
    0xE4, 0x24, 0x25, 0xE5, 0x27, 0xE7, 0xE6, 0x26, 0x22, 0xE2, 0xE3, 0x23, 0xE1, 0x21, 0x20, 0xE0,
    0xA0, 0x60, 0x61, 0xA1, 0x63, 0xA3, 0xA2, 0x62, 0x66, 0xA6, 0xA7, 0x67, 0xA5, 0x65, 0x64, 0xA4,
    0x6C, 0xAC, 0xAD, 0x6D, 0xAF, 0x6F, 0x6E, 0xAE, 0xAA, 0x6A, 0x6B, 0xAB, 0x69, 0xA9, 0xA8, 0x68,
    0x78, 0xB8, 0xB9, 0x79, 0xBB, 0x7B, 0x7A, 0xBA, 0xBE, 0x7E, 0x7F, 0xBF, 0x7D, 0xBD, 0xBC, 0x7C,
    0xB4, 0x74, 0x75, 0xB5, 0x77, 0xB7, 0xB6, 0x76, 0x72, 0xB2, 0xB3, 0x73, 0xB1, 0x71, 0x70, 0xB0,
    0x50, 0x90, 0x91, 0x51, 0x93, 0x53, 0x52, 0x92, 0x96, 0x56, 0x57, 0x97, 0x55, 0x95, 0x94, 0x54,
    0x9C, 0x5C, 0x5D, 0x9D, 0x5F, 0x9F, 0x9E, 0x5E, 0x5A, 0x9A, 0x9B, 0x5B, 0x99, 0x59, 0x58, 0x98,
    0x88, 0x48, 0x49, 0x89, 0x4B, 0x8B, 0x8A, 0x4A, 0x4E, 0x8E, 0x8F, 0x4F, 0x8D, 0x4D, 0x4C, 0x8C,
    0x44, 0x84, 0x85, 0x45, 0x87, 0x47, 0x46, 0x86, 0x82, 0x42, 0x43, 0x83, 0x41, 0x81, 0x80, 0x40
];

/**
 * Compute CRC-16 for a data buffer.
 * Fardriver uses CRC-16 with Modbus tables but init=0x3C7F (not standard 0xFFFF).
 * @param {Uint8Array} data
 * @param {number} length
 * @returns {[number, number]} [crcHi, crcLo]
 */
function computeCRC(data, length) {
    let crcHi = 0x3C;
    let crcLo = 0x7F;
    for (let i = 0; i < length; i++) {
        const idx = crcHi ^ data[i];
        crcHi = crcLo ^ crcTableHi[idx];
        crcLo = crcTableLo[idx];
    }
    return [crcHi, crcLo];
}

/**
 * Flash read address lookup table.
 * Maps message ID (0-54) to flash memory address.
 * Each ID maps to 6 consecutive 16-bit values starting at flash_read_addr[id].
 */
const FLASH_READ_ADDR = [
    0x00, 0x06, 0x0C, 0x12, 0x18, 0x1E, 0x24, 0x2A,
    0x30, 0x36, 0x3C, 0x42, 0x48, 0x4E, 0x54, 0x5A,
    0x60, 0x63, 0x69, 0x6F, 0x75, 0x7B, 0x7C, 0x82,
    0x88, 0x8E, 0x94, 0x9A, 0xA0, 0xA6, 0xAC, 0xB2,
    0xB8, 0xBE, 0xC4, 0xCA, 0xD0, 0xD6, 0xDC, 0xE2,
    0xE8, 0xEE, 0xF4, 0xFA, 0x100, 0x106, 0x10C, 0x112,
    0x118, 0x11E, 0x124, 0x12A, 0x130, 0x136, 0x13C
];

/**
 * Position sensor types
 */
const POSITION_SENSORS = {
    0: 'Hall',
    1: 'Encoder',
    2: 'Sensorless',
    3: 'Resolver'
};

/**
 * Temperature sensor types
 */
const TEMP_SENSORS = {
    0: 'None',
    1: 'KTY83',
    2: 'KTY84',
    3: 'PT1000',
    4: 'NTC 10K',
    5: 'NTC 5K',
    6: 'PTC'
};

/**
 * Throttle response types
 */
const THROTTLE_RESPONSES = {
    0: 'Linear',
    1: 'Sport',
    2: 'ECO'
};

/**
 * Brake configuration types
 */
const BRAKE_CONFIGS = {
    0: 'Disabled',
    1: 'Low Level',
    2: 'High Level',
    3: 'Analog'
};

/**
 * Follow configuration types
 */
const FOLLOW_CONFIGS = {
    0: 'Disabled',
    1: 'Enabled',
    2: 'EABS Brake',
    3: 'EABS Throttle'
};

/**
 * Gear configuration types
 */
const GEAR_CONFIGS = {
    0: 'Single Speed',
    1: 'Three Speed',
    2: 'Custom'
};

/**
 * Pin assignment options
 */
const PIN_OPTIONS = {
    0: 'None',
    1: 'PIN 1 (Low)',
    2: 'PIN 1 (High)',
    3: 'PIN 2 (Low)',
    4: 'PIN 2 (High)',
    5: 'PIN 3 (Low)',
    6: 'PIN 3 (High)',
    7: 'PIN 4 (Low)',
    8: 'PIN 4 (High)',
    9: 'PIN 5 (Low)',
    10: 'PIN 5 (High)',
    11: 'PIN 6 (Low)',
    12: 'PIN 6 (High)',
    13: 'PIN 7 (Low)',
    14: 'PIN 7 (High)',
    15: 'PIN 8 (Low)',
    16: 'PIN 8 (High)'
};

/**
 * RPM points for current limiting curves (18 points)
 */
const CURRENT_CURVE_RPM = [
    500, 1000, 1500, 2000, 2500, 3000, 3500, 4000,
    4500, 5000, 5500, 6000, 6500, 7000, 7500, 8000,
    8500, 9000
];

/**
 * FardriverData holds all decoded parameters and real-time values.
 */
class FardriverData {
    constructor() {
        this.reset();
    }

    reset() {
        // Raw flash storage: each address holds a uint16
        this._flash = new Uint16Array(0x140);

        // Real-time status (from address 0xE2)
        this.forward = false;
        this.reverse = false;
        this.gear = 0; // 0-3
        this.brake = false;
        this.motion = false;
        this.modulation = 0; // %
        this.measureSpeed = 0; // RPM

        // Error flags
        this.hallError = false;
        this.throttleError = false;
        this.voltageProtect = false;
        this.tempProtect = false;
        this.mosfetCheck = false;
        this.overcurrent = false;

        // Real-time from 0xE8
        this.deciVolts = 0;
        this.voltage = 0;
        this.lineCurrent = 0;
        this.throttleDepth = 0;

        // Real-time from 0xEE
        this.phaseACurrent = 0;
        this.phaseCCurrent = 0;
        this.secondaryVolts = 0;

        // Real-time from 0xF4
        this.motorTemp = 0;
        this.controllerTemp = 0;
        this.batterySOC = 0;
        this.firmwareYear = 0;
        this.firmwareMonth = 0;
        this.firmwareDay = 0;
        this.exeTime = 0;

        // Computed
        this.power = 0;
        this.speedKmh = 0;

        // Config parameters (populated from flash reads)
        // Address 0x00
        this.volCoeff = 0;
        this.voltage2Coeff = 0;
        this.phaseACoeff = 0;
        this.lineCoeff = 0;
        this.phaseCCoeff = 0;

        // Address 0x06
        this.antiTheftPulse = 0;
        this.protocol485 = 0;
        this.morseCode = 0;
        this.speedKI = 0;
        this.speedKP = 0;
        this.throttleLow = 0;
        this.throttleHigh = 0;
        this.faif = 0;
        this.curveTime = 0;
        this.brakeConfig = 0;
        this.tempSensor = 0;
        this.phaseExchange = 0;
        this.slowDown = 0;
        this.currAntiTheft = 0;
        this.parkConfig = 0;
        this.direction = 0;

        // Address 0x0C
        this.phaseOffset = 0;
        this.zeroBattCoeff = 0;
        this.fullBattCoeff = 0;
        this.ki1 = 0;
        this.kp1 = 0;
        this.ki2 = 0;
        this.kp2 = 0;

        // Address 0x12
        this.ld = 0;
        this.alarmDelay = 0;
        this.polePairs = 0;
        this.maxSpeed = 0;
        this.ratedPower = 0;
        this.ratedVoltage = 0;

        // Address 0x18
        this.ratedSpeed = 0;
        this.maxLineCurrent = 0;
        this.followConfig = 0;
        this.throttleResponse = 0;
        this.weakA = 0;
        this.speedPulse = 0;
        this.gearConfig = 0;
        this.lq = 0;
        this.battRatedCap = 0;
        this.intRes = 0;

        // Address 0x1E
        this.fwReRatio = 0;
        this.lowVolProtect = 0;
        this.customCode = 0;
        this.bcState = false;
        this.seatEnable = false;
        this.pEnable = false;
        this.cruiseEnable = false;
        this.eabsEnable = false;
        this.pushEnable = false;
        this.forceAntiTheft = false;
        this.overSpeedAlarm = false;
        this.brakeStillPark = false;
        this.rememberGear = false;
        this.backEnable = false;
        this.modelYear = 0;
        this.modelMonth = 0;
        this.modelDay = 0;

        // Address 0x24
        this.highVolProtect = 0;
        this.customMaxLineCurr = 0;
        this.customMaxPhaseCurr = 0;
        this.backSpeed = 0;
        this.lowSpeed = 0;

        // Address 0x2A
        this.midSpeed = 0;
        this.maxPhaseCurrent = 0;
        this.maxAcc = 0;
        this.maxDec = 0;

        // Address 0x30
        this.stopBackCurr = 0;
        this.maxBackCurr = 0;
        this.lowSpeedLineCurr = 0;
        this.midSpeedLineCurr = 0;
        this.lowSpeedPhaseCurr = 0;
        this.midSpeedPhaseCurr = 0;

        // Address 0x63
        this.maxLineCurr2 = 0;
        this.maxPhaseCurr2 = 0;
        this.boostLineCurr = 0;
        this.boostPhaseCurr = 0;

        // Address 0x69 - Pin assignments
        this.pausePin = 0;
        this.sideStandPin = 0;
        this.cruisePin = 0;
        this.boostPin = 0;
        this.lowSpeedPin = 0;
        this.highSpeedPin = 0;
        this.reversePin = 0;
        this.forwardPin = 0;
        this.switchVolPin = 0;
        this.seatPin = 0;
        this.antiTheftPin = 0;
        this.chargePin = 0;
        this.lmtSpeed = 0;
        this.distance = 0;

        // Address 0x7C
        this.totalTime = 0;

        // Address 0x82
        this.throttleVoltage = 0;
        this.highVolRestore = 0;
        this.motorTempProtect = 0;
        this.motorTempRestore = 0;
        this.mosTempProtect = 0;
        this.mosTempRestore = 0;
        this.hardwareVersion = 0;
        this.softwareVersion = 0;

        // Speed limit RPM
        this.speedLimitRPM = 0;

        // Free throttle
        this.freeThrottle = 0;

        // Position sensor type
        this.positionSensor = 0;

        // Weak magnetic properties
        this.weakMagnetic = 0;
        this.weakResponse = 0;
        this.ldvol = 0;
        this.lqvol = 0;

        // Current ratio tables (18 points each)
        this.currentRatioTable1 = new Array(18).fill(100);
        this.currentRatioTable2 = new Array(18).fill(100);
        this.regenRatioTable = new Array(18).fill(100);

        // Timestamps
        this.lastUpdate = 0;
        this.configLoaded = false;
    }

    /**
     * Store 6 uint16 values starting at a flash base address.
     * @param {number} baseAddr - Base flash address
     * @param {Uint8Array} data - 12 bytes of data (6 x uint16 LE)
     */
    storeFlash(baseAddr, data) {
        for (let i = 0; i < 6; i++) {
            const val = data[i * 2] | (data[i * 2 + 1] << 8);
            if (baseAddr + i < this._flash.length) {
                this._flash[baseAddr + i] = val;
            }
        }
        this._decodeFlash(baseAddr);
    }

    /**
     * Decode real-time status data from address 0xE2.
     * @param {Uint8Array} data - 12 bytes
     */
    decodeStatus_E2(data) {
        // Byte 0: status flags byte 0
        this.forward = !!(data[0] & 0x01);
        this.reverse = !!(data[0] & 0x02);
        this.gear = (data[0] >> 2) & 0x03;
        this.slidingBackwards = !!(data[0] & 0x10);
        this.motion = !!(data[0] & 0x20);

        // Byte 1: status flags byte 1
        this.phaseAActive = !!(data[1] & 0x01);
        this.phaseBActive = !!(data[1] & 0x02);
        this.phaseCActive = !!(data[1] & 0x04);
        this.passOK = (data[1] >> 3) & 0x03;
        this.mosfetCheck = !!(data[1] & 0x80);

        // Byte 2: protection flags
        this.hallError = !!(data[2] & 0x01);
        this.throttleError = !!(data[2] & 0x02);
        this.voltageProtect = !!(data[2] & 0x10);
        this.motorTempProtect = !!(data[2] & 0x40);
        this.controllerTempProtect = !!(data[2] & 0x80);

        // Byte 3: more protection flags
        this.brake = !!(data[3] & 0x80);

        // Byte 4: modulation (uint8, / 128 => %)
        this.modulation = data[4] / 128;

        // Byte 6-7: MeasureSpeed (uint16, RPM)
        this.measureSpeed = data[6] | (data[7] << 8);
        if (this.measureSpeed > 32767) this.measureSpeed -= 65536;

        this.lastUpdate = Date.now();
    }

    /**
     * Decode real-time data from address 0xE8.
     * @param {Uint8Array} data - 12 bytes
     */
    decodeStatus_E8(data) {
        // Byte 0-1: deci_volts (int16 BE, scaled by voltage divider coefficient)
        // Raw value is halved by hardware voltage divider. VolCoeff ≈ 2.034375
        // derived from known battery voltage. TODO: read VolCoeff from flash addr 0x00.
        const rawVolts = (data[0] << 8) | data[1];
        this.deciVolts = rawVolts > 32767 ? rawVolts - 65536 : rawVolts;
        this.voltage = this.deciVolts * 0.2034375;

        // Byte 2-3: per_mille (int16 BE, analog reference)
        const rawPm = (data[2] << 8) | data[3];
        this.perMille = rawPm > 32767 ? rawPm - 65536 : rawPm;

        // Byte 4-5: lineCurrent (int16 BE, / 4 for amps)
        const rawCurr = (data[4] << 8) | data[5];
        this.lineCurrent = (rawCurr > 32767 ? rawCurr - 65536 : rawCurr) / 4;

        // Byte 10-11: ThrottleDepth - not reliable from this packet (flash config)
        // Real-time throttle comes from status when motor is active

        // Compute power
        this.power = this.voltage * this.lineCurrent;

        // Compute SOC from voltage (20S LiPo: 60V empty, 84V full)
        const socMin = 60;
        const socMax = 84;
        this.batterySOC = Math.round(Math.max(0, Math.min(100,
            100 * (this.voltage - socMin) / (socMax - socMin))));

        this.lastUpdate = Date.now();
    }

    /**
     * Decode real-time data from address 0xEE.
     * @param {Uint8Array} data - 12 bytes
     */
    decodeStatus_EE(data) {
        // EE block contains pin states and phase zero data (config),
        // not real-time phase currents. Phase currents come from E8 lineCurrent.
        // Store raw data for config/diagnostics.
        this.eeRaw = Array.from(data);

        this.lastUpdate = Date.now();
    }

    /**
     * Decode real-time data from address 0xF4.
     * @param {Uint8Array} data - 12 bytes
     */
    decodeStatus_F4(data) {
        // Byte 0: firmware/hardware marker
        // Byte 1: motor_temp (uint8, Celsius)
        this.motorTemp = data[1];

        // Byte 2: unkF5 (int8)
        // Byte 3: batt_cap (int8) - raw controller value, SOC computed from voltage in E8

        // Byte 4: unkF6
        // Byte 5: ModifyYear (+ 2000)
        this.firmwareYear = data[5] + 2000;
        // Byte 6: ModifyMonth
        this.firmwareMonth = data[6];
        // Byte 7: ModifyDay
        this.firmwareDay = data[7];

        // Byte 8-9: EXETotal (uint16, / 8.0 for microseconds)
        this.exeTotal = (data[8] | (data[9] << 8)) / 8;
        // Byte 10-11: EXESingle (uint16, / 8.0 for microseconds)
        this.exeSingle = (data[10] | (data[11] << 8)) / 8;

        this.lastUpdate = Date.now();
    }

    /**
     * Decode flash data at a given base address into named fields.
     * @param {number} baseAddr
     */
    _decodeFlash(baseAddr) {
        const f = this._flash;

        switch (baseAddr) {
            case 0x00:
                this.volCoeff = f[0x00];
                this.voltage2Coeff = f[0x01];
                this.phaseACoeff = f[0x02];
                this.lineCoeff = f[0x03];
                this.phaseCCoeff = f[0x04];
                this.positionSensor = f[0x05];
                break;

            case 0x06:
                this.antiTheftPulse = f[0x06];
                this.protocol485 = f[0x07];
                this.morseCode = f[0x08];
                this.speedKI = f[0x09];
                this.speedKP = f[0x0A];
                // Combined byte fields
                this.throttleLow = f[0x0B] & 0xFF;
                this.throttleHigh = (f[0x0B] >> 8) & 0xFF;
                break;

            case 0x0C:
                this.faif = f[0x0C] & 0xFF;
                this.curveTime = (f[0x0C] >> 8) & 0xFF;
                this.brakeConfig = f[0x0D] & 0xFF;
                this.tempSensor = (f[0x0D] >> 8) & 0xFF;
                this.phaseExchange = f[0x0E] & 0x01;
                this.slowDown = (f[0x0E] >> 8) & 0xFF;
                this.currAntiTheft = f[0x0F] & 0xFF;
                this.parkConfig = (f[0x0F] >> 8) & 0xFF;
                this.direction = f[0x10] & 0x01;
                this.phaseOffset = (f[0x10] >> 8) & 0xFF;
                this.zeroBattCoeff = f[0x11];
                break;

            case 0x12:
                this.fullBattCoeff = f[0x12];
                this.ki1 = f[0x13];
                this.kp1 = f[0x14];
                this.ld = f[0x15] & 0xFF;
                this.alarmDelay = (f[0x15] >> 8) & 0xFF;
                this.polePairs = f[0x16];
                this.maxSpeed = f[0x17];
                break;

            case 0x18:
                this.ratedPower = f[0x18];
                this.ratedVoltage = f[0x19];
                this.ratedSpeed = f[0x1A];
                this.maxLineCurrent = f[0x1B];
                this.followConfig = f[0x1C] & 0xFF;
                this.throttleResponse = (f[0x1C] >> 8) & 0xFF;
                this.weakA = f[0x1D] & 0xFF;
                this.speedPulse = (f[0x1D] >> 8) & 0xFF;
                break;

            case 0x1E:
                this.gearConfig = f[0x1E] & 0xFF;
                this.lq = (f[0x1E] >> 8) & 0xFF;
                this.battRatedCap = f[0x1F];
                this.intRes = f[0x20];
                this.fwReRatio = f[0x21];
                this.lowVolProtect = f[0x22];
                // Feature flags from f[0x23]
                this.customCode = f[0x23] & 0x0F;
                this.bcState = !!(f[0x23] & 0x10);
                this.seatEnable = !!(f[0x23] & 0x20);
                this.pEnable = !!(f[0x23] & 0x40);
                this.cruiseEnable = !!(f[0x23] & 0x80);
                this.eabsEnable = !!(f[0x23] & 0x100);
                this.pushEnable = !!(f[0x23] & 0x200);
                this.forceAntiTheft = !!(f[0x23] & 0x400);
                this.overSpeedAlarm = !!(f[0x23] & 0x800);
                this.brakeStillPark = !!(f[0x23] & 0x1000);
                this.rememberGear = !!(f[0x23] & 0x2000);
                this.backEnable = !!(f[0x23] & 0x4000);
                break;

            case 0x24:
                this.modelYear = f[0x24] & 0xFF;
                this.modelMonth = (f[0x24] >> 8) & 0xFF;
                this.modelDay = f[0x25] & 0xFF;
                this.highVolProtect = f[0x26];
                this.customMaxLineCurr = f[0x27];
                this.customMaxPhaseCurr = f[0x28];
                this.backSpeed = f[0x29];
                break;

            case 0x2A:
                this.lowSpeed = f[0x2A];
                this.midSpeed = f[0x2B];
                this.maxPhaseCurrent = f[0x2C];
                this.maxAcc = f[0x2D];
                this.maxDec = f[0x2E];
                this.freeThrottle = f[0x2F];
                break;

            case 0x30:
                this.stopBackCurr = f[0x30];
                this.maxBackCurr = f[0x31];
                this.lowSpeedLineCurr = f[0x32];
                this.midSpeedLineCurr = f[0x33];
                this.lowSpeedPhaseCurr = f[0x34];
                this.midSpeedPhaseCurr = f[0x35];
                break;

            case 0x63:
                this.maxLineCurr2 = f[0x63];
                this.maxPhaseCurr2 = f[0x64];
                this.boostLineCurr = f[0x65];
                this.boostPhaseCurr = f[0x66];
                this.weakMagnetic = f[0x67];
                this.weakResponse = f[0x68] & 0x07;
                break;

            case 0x69:
                this.pausePin = f[0x69] & 0xFF;
                this.sideStandPin = (f[0x69] >> 8) & 0xFF;
                this.cruisePin = f[0x6A] & 0xFF;
                this.boostPin = (f[0x6A] >> 8) & 0xFF;
                this.lowSpeedPin = f[0x6B] & 0xFF;
                this.highSpeedPin = (f[0x6B] >> 8) & 0xFF;
                this.reversePin = f[0x6C] & 0xFF;
                this.forwardPin = (f[0x6C] >> 8) & 0xFF;
                this.switchVolPin = f[0x6D] & 0xFF;
                this.seatPin = (f[0x6D] >> 8) & 0xFF;
                this.antiTheftPin = f[0x6E] & 0xFF;
                this.chargePin = (f[0x6E] >> 8) & 0xFF;
                break;

            case 0x6F:
                this.lmtSpeed = f[0x6F];
                this.speedLimitRPM = f[0x70];
                break;

            case 0x7B:
            case 0x7C:
                this.totalTime = f[0x7C] | (f[0x7D] << 16);
                this.distance = f[0x7E] | (f[0x7F] << 16);
                break;

            case 0x82:
                this.throttleVoltage = f[0x82];
                this.highVolRestore = f[0x83];
                this.motorTempProtect = f[0x84];
                this.motorTempRestore = f[0x85];
                this.mosTempProtect = f[0x86];
                this.mosTempRestore = f[0x87];
                break;

            case 0x88:
                this.hardwareVersion = f[0x88];
                this.softwareVersion = f[0x89];
                this.ldvol = f[0x8A];
                this.lqvol = f[0x8B];
                break;

            default:
                // Current ratio tables: addresses 0x8E - 0xD6
                if (baseAddr >= 0x8E && baseAddr <= 0xD6) {
                    this._decodeCurrentTables();
                }
                break;
        }

        this.configLoaded = true;
    }

    /**
     * Decode current ratio tables from flash.
     * Tables span addresses 0x8E to ~0xD6, each entry is a uint16 representing %.
     */
    _decodeCurrentTables() {
        const f = this._flash;
        // Table 1: line current ratios at each RPM point
        for (let i = 0; i < 18; i++) {
            if (0x8E + i < f.length) {
                this.currentRatioTable1[i] = f[0x8E + i];
            }
        }
        // Table 2: phase current ratios
        for (let i = 0; i < 18; i++) {
            if (0xA0 + i < f.length) {
                this.currentRatioTable2[i] = f[0xA0 + i];
            }
        }
        // Regen table
        for (let i = 0; i < 18; i++) {
            if (0xB8 + i < f.length) {
                this.regenRatioTable[i] = f[0xB8 + i];
            }
        }
    }

    /**
     * Get the gear name.
     */
    get gearName() {
        if (this.reverse) return 'R';
        switch (this.gear) {
            case 0: return 'N';
            case 1: return 'D1';
            case 2: return 'D2';
            case 3: return 'D3';
            default: return 'N';
        }
    }

    /**
     * Check if any error is active.
     */
    get hasError() {
        return this.hallError || this.throttleError || this.voltageProtect ||
               this.tempProtect || this.mosfetCheck || this.overcurrent;
    }

    /**
     * Get list of active errors.
     */
    get activeErrors() {
        const errors = [];
        if (this.hallError) errors.push('Hall Sensor');
        if (this.throttleError) errors.push('Throttle');
        if (this.voltageProtect) errors.push('Voltage');
        if (this.tempProtect) errors.push('Temperature');
        if (this.mosfetCheck) errors.push('MOSFET');
        if (this.overcurrent) errors.push('Overcurrent');
        return errors;
    }

    /**
     * Get display voltage values.
     */
    get ratedVoltageDisplay() { return this.ratedVoltage / 10; }
    get lowVolProtectDisplay() { return this.lowVolProtect / 10; }
    get highVolProtectDisplay() { return this.highVolProtect / 10; }
    get maxLineCurrentDisplay() { return this.maxLineCurrent / 4; }
    get maxPhaseCurrentDisplay() { return this.maxPhaseCurrent / 4; }
    get customMaxLineCurrDisplay() { return this.customMaxLineCurr / 4; }
    get customMaxPhaseCurrDisplay() { return this.customMaxPhaseCurr / 4; }
    get throttleLowVoltage() { return this.throttleLow / 20; }
    get throttleHighVoltage() { return this.throttleHigh / 20; }

    /**
     * Export all configuration parameters as a JSON-compatible object.
     */
    exportConfig() {
        return {
            version: 1,
            timestamp: new Date().toISOString(),
            motor: {
                positionSensor: this.positionSensor,
                tempSensor: this.tempSensor,
                phaseOffset: this.phaseOffset,
                polePairs: this.polePairs,
                direction: this.direction,
                ratedSpeed: this.ratedSpeed,
                ratedVoltage: this.ratedVoltage,
                ratedPower: this.ratedPower,
                maxSpeed: this.maxSpeed,
                phaseExchange: this.phaseExchange
            },
            currentLimits: {
                maxLineCurrent: this.maxLineCurrent,
                maxPhaseCurrent: this.maxPhaseCurrent,
                customMaxLineCurr: this.customMaxLineCurr,
                customMaxPhaseCurr: this.customMaxPhaseCurr,
                boostLineCurr: this.boostLineCurr,
                boostPhaseCurr: this.boostPhaseCurr
            },
            speed: {
                backSpeed: this.backSpeed,
                lowSpeed: this.lowSpeed,
                midSpeed: this.midSpeed,
                speedLimitRPM: this.speedLimitRPM,
                lowSpeedLineCurr: this.lowSpeedLineCurr,
                lowSpeedPhaseCurr: this.lowSpeedPhaseCurr,
                midSpeedLineCurr: this.midSpeedLineCurr,
                midSpeedPhaseCurr: this.midSpeedPhaseCurr
            },
            throttle: {
                throttleLow: this.throttleLow,
                throttleHigh: this.throttleHigh,
                throttleResponse: this.throttleResponse,
                maxAcc: this.maxAcc,
                maxDec: this.maxDec,
                freeThrottle: this.freeThrottle
            },
            battery: {
                ratedVoltage: this.ratedVoltage,
                lowVolProtect: this.lowVolProtect,
                highVolProtect: this.highVolProtect,
                battRatedCap: this.battRatedCap,
                intRes: this.intRes
            },
            braking: {
                brakeConfig: this.brakeConfig,
                stopBackCurr: this.stopBackCurr,
                maxBackCurr: this.maxBackCurr,
                followConfig: this.followConfig
            },
            protection: {
                motorTempProtect: this.motorTempProtect,
                motorTempRestore: this.motorTempRestore,
                mosTempProtect: this.mosTempProtect,
                mosTempRestore: this.mosTempRestore,
                alarmDelay: this.alarmDelay
            },
            features: {
                cruiseEnable: this.cruiseEnable,
                eabsEnable: this.eabsEnable,
                pushEnable: this.pushEnable,
                pEnable: this.pEnable,
                seatEnable: this.seatEnable,
                forceAntiTheft: this.forceAntiTheft,
                overSpeedAlarm: this.overSpeedAlarm,
                brakeStillPark: this.brakeStillPark,
                rememberGear: this.rememberGear,
                backEnable: this.backEnable
            },
            pins: {
                pausePin: this.pausePin,
                sideStandPin: this.sideStandPin,
                cruisePin: this.cruisePin,
                boostPin: this.boostPin,
                lowSpeedPin: this.lowSpeedPin,
                highSpeedPin: this.highSpeedPin,
                reversePin: this.reversePin,
                forwardPin: this.forwardPin,
                switchVolPin: this.switchVolPin,
                seatPin: this.seatPin,
                antiTheftPin: this.antiTheftPin,
                chargePin: this.chargePin
            },
            advanced: {
                gearConfig: this.gearConfig,
                speedPulse: this.speedPulse,
                weakMagnetic: this.weakMagnetic,
                weakResponse: this.weakResponse,
                ldvol: this.ldvol,
                lqvol: this.lqvol,
                faif: this.faif
            },
            currentCurves: {
                table1: [...this.currentRatioTable1],
                table2: [...this.currentRatioTable2],
                regenTable: [...this.regenRatioTable]
            }
        };
    }

    /**
     * Import configuration from a JSON object.
     * Returns an array of {addr, value} pairs to write.
     */
    importConfig(config) {
        if (!config || config.version !== 1) {
            throw new Error('Invalid configuration format');
        }
        // Just populate the data object; actual writes happen via protocol
        const writes = [];

        if (config.motor) {
            for (const [key, val] of Object.entries(config.motor)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.currentLimits) {
            for (const [key, val] of Object.entries(config.currentLimits)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.speed) {
            for (const [key, val] of Object.entries(config.speed)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.throttle) {
            for (const [key, val] of Object.entries(config.throttle)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.battery) {
            for (const [key, val] of Object.entries(config.battery)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.braking) {
            for (const [key, val] of Object.entries(config.braking)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.protection) {
            for (const [key, val] of Object.entries(config.protection)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.features) {
            for (const [key, val] of Object.entries(config.features)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.pins) {
            for (const [key, val] of Object.entries(config.pins)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.advanced) {
            for (const [key, val] of Object.entries(config.advanced)) {
                if (this[key] !== undefined) this[key] = val;
            }
        }
        if (config.currentCurves) {
            if (config.currentCurves.table1) this.currentRatioTable1 = [...config.currentCurves.table1];
            if (config.currentCurves.table2) this.currentRatioTable2 = [...config.currentCurves.table2];
            if (config.currentCurves.regenTable) this.regenRatioTable = [...config.currentCurves.regenTable];
        }

        return this;
    }
}


/**
 * FardriverProtocol handles packet parsing and command construction.
 */
class FardriverProtocol {
    constructor() {
        this.data = new FardriverData();
        this._buffer = new Uint8Array(256);
        this._bufferPos = 0;
        this._onData = null;
        this._packetCount = 0;
        this._crcErrors = 0;
    }

    /**
     * Reset protocol state.
     */
    reset() {
        this._bufferPos = 0;
        this._packetCount = 0;
        this._crcErrors = 0;
        this.data.reset();
    }

    /**
     * Set data callback.
     * @param {Function} callback
     */
    set onData(callback) {
        this._onData = callback;
    }

    /**
     * Feed incoming BLE data into the parser.
     * Accumulates bytes, finds 0xAA headers, validates CRC, decodes packets.
     * @param {Uint8Array} incoming
     * @returns {FardriverData|null}
     */
    feed(incoming) {
        // Append to buffer
        for (let i = 0; i < incoming.length; i++) {
            if (this._bufferPos < this._buffer.length) {
                this._buffer[this._bufferPos++] = incoming[i];
            }
        }

        let parsed = false;

        // Scan for complete 16-byte packets starting with 0xAA
        while (this._bufferPos >= 16) {
            // Find 0xAA header
            let headerIdx = -1;
            for (let i = 0; i <= this._bufferPos - 16; i++) {
                if (this._buffer[i] === 0xAA) {
                    headerIdx = i;
                    break;
                }
            }

            if (headerIdx === -1) {
                // No header found, discard all but last byte
                this._buffer[0] = this._buffer[this._bufferPos - 1];
                this._bufferPos = 1;
                break;
            }

            // Discard bytes before header
            if (headerIdx > 0) {
                this._buffer.copyWithin(0, headerIdx);
                this._bufferPos -= headerIdx;
            }

            if (this._bufferPos < 16) break;

            // Extract 16-byte packet
            const packet = this._buffer.slice(0, 16);

            // Validate CRC (bytes 0-13, CRC at 14-15)
            const [expectedHi, expectedLo] = computeCRC(packet, 14);
            if (packet[14] === expectedHi && packet[15] === expectedLo) {
                this._parsePacket(packet);
                parsed = true;
                this._packetCount++;
            } else {
                this._crcErrors++;
                // Try next byte
            }

            // Remove processed packet
            this._buffer.copyWithin(0, 16);
            this._bufferPos -= 16;
        }

        if (parsed) {
            if (this._onData) this._onData(this.data);
            return this.data;
        }
        return null;
    }

    /**
     * Parse a validated 16-byte packet.
     * @param {Uint8Array} packet
     */
    _parsePacket(packet) {
        const data = packet.slice(2, 14); // 12 bytes of payload

        // byte[1] is a sequential index: 0x80 + n maps to FLASH_READ_ADDR[n]
        const index = packet[1] - 0x80;
        if (index < 0 || index >= FLASH_READ_ADDR.length) {
            return; // Out of range
        }

        const addr = FLASH_READ_ADDR[index];

        // Debug: log status packets
        if (addr >= 0xE2 && addr <= 0xFA) {
            console.log('[STATUS 0x' + addr.toString(16).toUpperCase() + '] idx=' + index +
                ' data=' + Array.from(data).map(b => b.toString(16).padStart(2, '0')).join(' '));
        }

        // Route status addresses to real-time decoders, rest to flash storage
        switch (addr) {
            case 0xE2:
                this.data.decodeStatus_E2(data);
                break;
            case 0xE8:
                this.data.decodeStatus_E8(data);
                break;
            case 0xEE:
                this.data.decodeStatus_EE(data);
                break;
            case 0xF4:
                this.data.decodeStatus_F4(data);
                break;
            default:
                this.data.storeFlash(addr, data);
                break;
        }
    }

    /**
     * Build an "old protocol" RS323-style command packet.
     * Format: [0xAA] [cmd] [~cmd] [sub_cmd] [value_1] [value_2] [checksum] [~checksum]
     * Checksum = sum of bytes 0-5 (truncated to uint8), last byte = ~checksum.
     * @param {number} command
     * @param {number} subCommand
     * @param {number} value1
     * @param {number} value2
     * @returns {Uint8Array}
     */
    buildRS323Command(command, subCommand, value1, value2) {
        const cmd = new Uint8Array(8);
        cmd[0] = 0xAA;
        cmd[1] = command;
        cmd[2] = (~command) & 0xFF;
        cmd[3] = subCommand;
        cmd[4] = value1;
        cmd[5] = value2;
        const sum = (cmd[0] + cmd[1] + cmd[2] + cmd[3] + cmd[4] + cmd[5]) & 0xFF;
        cmd[6] = sum;
        cmd[7] = (~sum) & 0xFF;
        return cmd;
    }

    /**
     * Get the Open/request command to initiate communication.
     * Old protocol: 0xAA 0x13 ~0x13 0x07 0x01 0xF1 [sum] [~sum]
     * @returns {Uint8Array}
     */
    get requestCommand() {
        return this.buildRS323Command(0x13, 0x07, 0x01, 0xF1);
    }

    /**
     * Get the KeepAlive command to maintain data flow.
     * Old protocol: 0xAA 0x13 ~0x13 0x07 0x5F 0x5F [sum] [~sum]
     * @returns {Uint8Array}
     */
    get keepAliveCommand() {
        return this.buildRS323Command(0x13, 0x07, 0x5F, 0x5F);
    }

    /**
     * Get the Close command sent on disconnect.
     * Old protocol: 0xAA 0x13 ~0x13 0x08 0x01 0xF1 [sum] [~sum]
     * @returns {Uint8Array}
     */
    get closeCommand() {
        return this.buildRS323Command(0x13, 0x08, 0x01, 0xF1);
    }

    /**
     * Build a write command for a parameter.
     * 8-byte write packet with flags=1.
     * Format: [0xAA] [addr<<2|0x01] [valueLo] [valueHi] [0x00 x 2] [CRC_hi] [CRC_lo]
     * @param {number} addr - Flash address to write
     * @param {number} value - uint16 value to write
     * @returns {Uint8Array}
     */
    writeParameter(addr, value) {
        const cmd = new Uint8Array(8);
        cmd[0] = 0xAA;
        cmd[1] = ((addr & 0x3F) << 2) | 0x01; // flags=1 for write
        cmd[2] = value & 0xFF;
        cmd[3] = (value >> 8) & 0xFF;
        cmd[4] = 0x00;
        cmd[5] = 0x00;
        const [crcHi, crcLo] = computeCRC(cmd, 6);
        cmd[6] = crcHi;
        cmd[7] = crcLo;
        return cmd;
    }

    /**
     * Build a system command.
     * Writes 0x88+cmd to address 0xA0.
     * @param {number} cmd - System command code
     * @returns {Uint8Array}
     */
    sendSystemCommand(cmd) {
        return this.writeParameter(0xA0, 0x88 + cmd);
    }

    /**
     * Start auto-learn process.
     * System command 0x02.
     * @returns {Uint8Array}
     */
    startAutoLearn() {
        return this.sendSystemCommand(0x02);
    }

    /**
     * Stop auto-learn process.
     * System command 0x03.
     * @returns {Uint8Array}
     */
    stopAutoLearn() {
        return this.sendSystemCommand(0x03);
    }

    /**
     * Reset controller to factory defaults.
     * System command 0x05.
     * @returns {Uint8Array}
     */
    resetController() {
        return this.sendSystemCommand(0x05);
    }

    /**
     * Save parameters to flash.
     * System command 0x01.
     * @returns {Uint8Array}
     */
    saveToFlash() {
        return this.sendSystemCommand(0x01);
    }

    /**
     * Get statistics about parsing.
     */
    get stats() {
        return {
            packetCount: this._packetCount,
            crcErrors: this._crcErrors,
            errorRate: this._packetCount > 0 ? (this._crcErrors / this._packetCount * 100).toFixed(1) : '0.0'
        };
    }
}

/**
 * Parameter definition map.
 * Maps parameter names to their flash addresses, data types, display info.
 */
const PARAM_MAP = {
    // Motor section
    positionSensor: { addr: 0x05, type: 'dropdown', options: POSITION_SENSORS, section: 'motor', label: 'Position Sensor' },
    tempSensor: { addr: 0x0D, type: 'dropdown', options: TEMP_SENSORS, section: 'motor', label: 'Temp Sensor', shift: 8, mask: 0xFF },
    phaseOffset: { addr: 0x10, type: 'number', section: 'motor', label: 'Phase Offset', shift: 8, mask: 0xFF },
    polePairs: { addr: 0x16, type: 'number', section: 'motor', label: 'Pole Pairs', min: 1, max: 50 },
    direction: { addr: 0x10, type: 'toggle', section: 'motor', label: 'Direction', mask: 0x01 },
    ratedSpeed: { addr: 0x1A, type: 'number', section: 'motor', label: 'Rated Speed (RPM)', min: 0, max: 20000 },
    ratedVoltage: { addr: 0x19, type: 'number', section: 'motor', label: 'Rated Voltage', divisor: 10, unit: 'V' },
    ratedPower: { addr: 0x18, type: 'number', section: 'motor', label: 'Rated Power (W)', min: 0, max: 50000 },
    maxSpeed: { addr: 0x17, type: 'number', section: 'motor', label: 'Max Speed (RPM)', min: 0, max: 20000 },
    phaseExchange: { addr: 0x0E, type: 'toggle', section: 'motor', label: 'Phase Exchange', mask: 0x01 },

    // Current Limits
    maxLineCurrent: { addr: 0x1B, type: 'number', section: 'current', label: 'Max Line Current', divisor: 4, unit: 'A' },
    maxPhaseCurrent: { addr: 0x2C, type: 'number', section: 'current', label: 'Max Phase Current', divisor: 4, unit: 'A' },
    customMaxLineCurr: { addr: 0x27, type: 'number', section: 'current', label: 'Custom Max Line Current', divisor: 4, unit: 'A' },
    customMaxPhaseCurr: { addr: 0x28, type: 'number', section: 'current', label: 'Custom Max Phase Current', divisor: 4, unit: 'A' },
    boostLineCurr: { addr: 0x65, type: 'number', section: 'current', label: 'Boost Line Current', unit: 'A' },
    boostPhaseCurr: { addr: 0x66, type: 'number', section: 'current', label: 'Boost Phase Current', unit: 'A' },

    // Speed
    backSpeed: { addr: 0x29, type: 'number', section: 'speed', label: 'Reverse Speed (RPM)' },
    lowSpeed: { addr: 0x2A, type: 'number', section: 'speed', label: 'Low Speed (RPM)' },
    midSpeed: { addr: 0x2B, type: 'number', section: 'speed', label: 'Mid Speed (RPM)' },
    speedLimitRPM: { addr: 0x70, type: 'number', section: 'speed', label: 'Speed Limit (RPM)' },
    lowSpeedLineCurr: { addr: 0x32, type: 'number', section: 'speed', label: 'Low Speed Line Current %', unit: '%' },
    lowSpeedPhaseCurr: { addr: 0x34, type: 'number', section: 'speed', label: 'Low Speed Phase Current %', unit: '%' },
    midSpeedLineCurr: { addr: 0x33, type: 'number', section: 'speed', label: 'Mid Speed Line Current %', unit: '%' },
    midSpeedPhaseCurr: { addr: 0x35, type: 'number', section: 'speed', label: 'Mid Speed Phase Current %', unit: '%' },

    // Throttle
    throttleLow: { addr: 0x0B, type: 'number', section: 'throttle', label: 'Throttle Low', divisor: 20, unit: 'V', mask: 0xFF },
    throttleHigh: { addr: 0x0B, type: 'number', section: 'throttle', label: 'Throttle High', divisor: 20, unit: 'V', shift: 8, mask: 0xFF },
    throttleResponse: { addr: 0x1C, type: 'dropdown', options: THROTTLE_RESPONSES, section: 'throttle', label: 'Throttle Response', shift: 8, mask: 0xFF },
    maxAcc: { addr: 0x2D, type: 'number', section: 'throttle', label: 'Acceleration Sensitivity', min: 0, max: 255 },
    maxDec: { addr: 0x2E, type: 'number', section: 'throttle', label: 'Deceleration Sensitivity', min: 0, max: 255 },
    freeThrottle: { addr: 0x2F, type: 'number', section: 'throttle', label: 'Free Throttle' },

    // Battery
    lowVolProtect: { addr: 0x22, type: 'number', section: 'battery', label: 'Low Voltage Protect', divisor: 10, unit: 'V' },
    highVolProtect: { addr: 0x26, type: 'number', section: 'battery', label: 'High Voltage Protect', divisor: 10, unit: 'V' },
    battRatedCap: { addr: 0x1F, type: 'number', section: 'battery', label: 'Battery Rated Capacity (Ah)' },
    intRes: { addr: 0x20, type: 'number', section: 'battery', label: 'Internal Resistance (mOhm)' },

    // Braking
    brakeConfig: { addr: 0x0D, type: 'dropdown', options: BRAKE_CONFIGS, section: 'braking', label: 'Brake Config', mask: 0xFF },
    stopBackCurr: { addr: 0x30, type: 'number', section: 'braking', label: 'Stop Back Current' },
    maxBackCurr: { addr: 0x31, type: 'number', section: 'braking', label: 'Max Back Current' },
    followConfig: { addr: 0x1C, type: 'dropdown', options: FOLLOW_CONFIGS, section: 'braking', label: 'Follow Config', mask: 0xFF },

    // Protection
    motorTempProtect: { addr: 0x84, type: 'number', section: 'protection', label: 'Motor Temp Protect', unit: '\u00B0C' },
    motorTempRestore: { addr: 0x85, type: 'number', section: 'protection', label: 'Motor Temp Restore', unit: '\u00B0C' },
    mosTempProtect: { addr: 0x86, type: 'number', section: 'protection', label: 'MOS Temp Protect', unit: '\u00B0C' },
    mosTempRestore: { addr: 0x87, type: 'number', section: 'protection', label: 'MOS Temp Restore', unit: '\u00B0C' },
    alarmDelay: { addr: 0x15, type: 'number', section: 'protection', label: 'Alarm Delay', shift: 8, mask: 0xFF },

    // Features (toggles)
    cruiseEnable: { addr: 0x23, type: 'toggle', section: 'features', label: 'Cruise Enable', bit: 7 },
    eabsEnable: { addr: 0x23, type: 'toggle', section: 'features', label: 'EABS Enable', bit: 8 },
    pushEnable: { addr: 0x23, type: 'toggle', section: 'features', label: 'Push Enable', bit: 9 },
    pEnable: { addr: 0x23, type: 'toggle', section: 'features', label: 'P Gear Enable', bit: 6 },
    seatEnable: { addr: 0x23, type: 'toggle', section: 'features', label: 'Seat Enable', bit: 5 },
    forceAntiTheft: { addr: 0x23, type: 'toggle', section: 'features', label: 'Force Anti-theft', bit: 10 },
    overSpeedAlarm: { addr: 0x23, type: 'toggle', section: 'features', label: 'Over-speed Alarm', bit: 11 },
    brakeStillPark: { addr: 0x23, type: 'toggle', section: 'features', label: 'Brake Still Park', bit: 12 },
    rememberGear: { addr: 0x23, type: 'toggle', section: 'features', label: 'Remember Gear', bit: 13 },
    backEnable: { addr: 0x23, type: 'toggle', section: 'features', label: 'Back Enable', bit: 14 },

    // Pins
    pausePin: { addr: 0x69, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Pause Pin', mask: 0xFF },
    sideStandPin: { addr: 0x69, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Side Stand Pin', shift: 8, mask: 0xFF },
    cruisePin: { addr: 0x6A, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Cruise Pin', mask: 0xFF },
    boostPin: { addr: 0x6A, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Boost Pin', shift: 8, mask: 0xFF },
    lowSpeedPin: { addr: 0x6B, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Low Speed Pin', mask: 0xFF },
    highSpeedPin: { addr: 0x6B, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'High Speed Pin', shift: 8, mask: 0xFF },
    reversePin: { addr: 0x6C, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Reverse Pin', mask: 0xFF },
    forwardPin: { addr: 0x6C, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Forward Pin', shift: 8, mask: 0xFF },
    switchVolPin: { addr: 0x6D, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Switch Vol Pin', mask: 0xFF },
    seatPin: { addr: 0x6D, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Seat Pin', shift: 8, mask: 0xFF },
    antiTheftPin: { addr: 0x6E, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Anti-theft Pin', mask: 0xFF },
    chargePin: { addr: 0x6E, type: 'dropdown', options: PIN_OPTIONS, section: 'pins', label: 'Charge Pin', shift: 8, mask: 0xFF },

    // Advanced
    gearConfig: { addr: 0x1E, type: 'dropdown', options: GEAR_CONFIGS, section: 'advanced', label: 'Gear Config', mask: 0xFF },
    speedPulse: { addr: 0x1D, type: 'number', section: 'advanced', label: 'Speed Pulse', shift: 8, mask: 0xFF },
    weakMagnetic: { addr: 0x67, type: 'number', section: 'advanced', label: 'Weak Magnetic Properties' },
    weakResponse: { addr: 0x68, type: 'number', section: 'advanced', label: 'Weak Response (0-6)', min: 0, max: 6, mask: 0x07 },
    ldvol: { addr: 0x8A, type: 'number', section: 'advanced', label: 'LDVOL' },
    lqvol: { addr: 0x8B, type: 'number', section: 'advanced', label: 'LQVOL' },
    faif: { addr: 0x0C, type: 'number', section: 'advanced', label: 'FAIF', mask: 0xFF },
    hardwareVersion: { addr: 0x88, type: 'readonly', section: 'advanced', label: 'Hardware Version' },
    softwareVersion: { addr: 0x89, type: 'readonly', section: 'advanced', label: 'Software Version' }
};

/**
 * Section definitions for the parameters UI.
 */
const PARAM_SECTIONS = {
    motor: { label: 'Motor', icon: '\u2699' },
    current: { label: 'Current Limits', icon: '\u26A1' },
    speed: { label: 'Speed', icon: '\uD83C\uDFC1' },
    throttle: { label: 'Throttle', icon: '\uD83C\uDFAE' },
    battery: { label: 'Battery', icon: '\uD83D\uDD0B' },
    braking: { label: 'Braking', icon: '\uD83D\uDED1' },
    protection: { label: 'Protection', icon: '\uD83D\uDEE1' },
    features: { label: 'Features', icon: '\u2699' },
    pins: { label: 'Pins', icon: '\uD83D\uDD0C' },
    advanced: { label: 'Advanced', icon: '\uD83D\uDD27' }
};
/**
 * Fardriver BLE Connection Manager
 * Handles Web Bluetooth communication with Fardriver motor controllers.
 *
 * Service UUID: 0xFFE0
 * Characteristic UUID: 0xFFE1 (notify + write)
 */


const FARDRIVER_SERVICE_UUID = 0xFFE0;
const FARDRIVER_CHAR_UUID = 0xFFE1;

const KNOWN_SERVICES = [
    0xFFE0,
    "0000ffe0-0000-1000-8000-00805f9b34fb"
];

class FardriverBLE extends EventTarget {
    constructor() {
        super();
        this.device = null;
        this.server = null;
        this.notifyChar = null;
        this.writeChar = null;
        this.protocol = new FardriverProtocol();
        this.connected = false;
        this._pollTimer = null;
        this._reconnectTimer = null;
        this._reconnectAttempts = 0;
        this._maxReconnectAttempts = 5;
        this._autoReconnect = true;
        this._dataLogging = false;
        this._dataLog = [];
        this._lastWriteTime = 0;
        this._writeQueue = [];
        this._writing = false;

        // Wire protocol data callback
        this.protocol.onData = (data) => {
            this.dispatchEvent(new CustomEvent('data', { detail: data }));
        };
    }

    get isSupported() {
        return !!navigator.bluetooth;
    }

    get deviceName() {
        return this.device?.name || this.device?.id || '--';
    }

    /**
     * Scan for Fardriver BLE devices.
     * @returns {Promise<BluetoothDevice>}
     */
    async scan() {
        if (!this.isSupported) {
            throw Object.assign(new Error('Web Bluetooth not supported'), { i18nKey: 'bleNotSupported' });
        }

        this.device = await navigator.bluetooth.requestDevice({
            acceptAllDevices: true,
            optionalServices: KNOWN_SERVICES,
        });

        this.device.addEventListener('gattserverdisconnected', () => {
            this._handleDisconnect();
        });

        return this.device;
    }

    /**
     * Connect to the selected device.
     * @returns {Promise<void>}
     */
    async connect() {
        if (!this.device) {
            throw Object.assign(new Error('No device selected'), { i18nKey: 'noDeviceSelected' });
        }

        try {
            // GATT connect with retry - BLE modules need time to become ready after disconnect
            let gattReady = false;
            for (let attempt = 0; attempt < 3 && !gattReady; attempt++) {
                if (attempt > 0) {
                    console.log('[BLE] GATT retry #' + (attempt + 1) + ', waiting ' + (1000 + attempt * 1000) + 'ms...');
                    await new Promise(r => setTimeout(r, 1000 + attempt * 1000));
                }
                try {
                    this.server = await this.device.gatt.connect();
                    await new Promise(r => setTimeout(r, 600));
                    if (this.server.connected) {
                        gattReady = true;
                    } else {
                        console.warn('[BLE] GATT connected but dropped during stabilization');
                    }
                } catch (e) {
                    console.warn('[BLE] GATT connect attempt ' + (attempt + 1) + ' failed:', e.message);
                }
            }

            if (!gattReady) {
                throw Object.assign(new Error('GATT connection failed after retries'), { i18nKey: 'gattDisconnected' });
            }

            const services = await this.server.getPrimaryServices();

            this.notifyChar = null;
            this.writeChar = null;

            for (const svc of services) {
                const chars = await svc.getCharacteristics();
                for (const ch of chars) {
                    // Prefer FFE1 but accept any notify+write characteristic
                    if (ch.properties.notify) {
                        if (!this.notifyChar || ch.uuid.includes('ffe1')) {
                            this.notifyChar = ch;
                        }
                    }
                    if (ch.properties.write || ch.properties.writeWithoutResponse) {
                        if (!this.writeChar || ch.uuid.includes('ffe1')) {
                            this.writeChar = ch;
                        }
                    }
                }
            }

            if (!this.notifyChar || !this.writeChar) {
                throw Object.assign(new Error('UART characteristics not found'), { i18nKey: 'uartNotFound' });
            }

            // Start notifications
            await this.notifyChar.startNotifications();
            this.notifyChar.addEventListener('characteristicvaluechanged', (e) => {
                this._onNotification(e);
            });

            this.connected = true;
            this._reconnectAttempts = 0;
            this.protocol.reset();

            this.dispatchEvent(new Event('connected'));

            // Send initial request command to start data flow
            await this._sendInitCommand();

            // Start polling for data
            this.startPolling();

        } catch (err) {
            this.connected = false;
            throw err;
        }
    }

    /**
     * Disconnect from the device.
     */
    async disconnect() {
        this._autoReconnect = false;
        this.stopPolling();
        this._clearReconnect();

        if (this.server && this.server.connected) {
            try {
                // Send close command before disconnecting
                const closeCmd = this.protocol.closeCommand;
                console.log('[BLE TX Close]', Array.from(closeCmd).map(b => b.toString(16).padStart(2, '0')).join(' '));
                await this.write(closeCmd);
            } catch (e) { /* ignore */ }
            try {
                if (this.notifyChar) {
                    await this.notifyChar.stopNotifications();
                }
            } catch (e) { /* ignore */ }
            this.server.disconnect();
        }

        this.connected = false;
        this.dispatchEvent(new Event('disconnected'));
    }

    /**
     * Handle unexpected disconnect.
     */
    _handleDisconnect() {
        const wasConnected = this.connected;
        this.connected = false;
        this.stopPolling();
        console.log('[BLE] Disconnected unexpectedly. wasConnected=' + wasConnected +
            ' autoReconnect=' + this._autoReconnect + ' attempts=' + this._reconnectAttempts);
        this.dispatchEvent(new Event('disconnected'));

        if (wasConnected && this._autoReconnect && this._reconnectAttempts < this._maxReconnectAttempts) {
            this._scheduleReconnect();
        }
    }

    /**
     * Schedule a reconnection attempt.
     */
    _scheduleReconnect() {
        this._clearReconnect();
        const delay = Math.min(1000 * Math.pow(2, this._reconnectAttempts), 10000);
        this._reconnectAttempts++;

        this.dispatchEvent(new CustomEvent('reconnecting', {
            detail: { attempt: this._reconnectAttempts, delay }
        }));

        this._reconnectTimer = setTimeout(async () => {
            try {
                await this.connect();
            } catch (e) {
                if (this._reconnectAttempts < this._maxReconnectAttempts) {
                    this._scheduleReconnect();
                } else {
                    this.dispatchEvent(new CustomEvent('reconnectFailed'));
                }
            }
        }, delay);
    }

    _clearReconnect() {
        if (this._reconnectTimer) {
            clearTimeout(this._reconnectTimer);
            this._reconnectTimer = null;
        }
    }

    /**
     * Send the initial open/request command.
     */
    async _sendInitCommand() {
        const cmd = this.protocol.requestCommand;
        console.log('[BLE TX]', Array.from(cmd).map(b => b.toString(16).padStart(2, '0')).join(' '));
        await this.write(cmd);
    }

    /**
     * Handle BLE notification data.
     */
    _onNotification(event) {
        const value = new Uint8Array(event.target.value.buffer);

        // Debug: log raw BLE data
        console.log('[BLE RX]', value.length, 'bytes:', Array.from(value).map(b => b.toString(16).padStart(2, '0')).join(' '));

        // Log if data logging is enabled
        if (this._dataLogging) {
            this._dataLog.push({
                timestamp: Date.now(),
                direction: 'rx',
                data: Array.from(value)
            });
        }

        this.protocol.feed(value);
    }

    /**
     * Write data to the controller.
     * @param {Uint8Array} data
     * @returns {Promise<void>}
     */
    async write(data) {
        if (!this.writeChar || !this.connected) {
            throw new Error('Not connected');
        }

        // Queue writes to avoid BLE congestion
        return new Promise((resolve, reject) => {
            this._writeQueue.push({ data, resolve, reject });
            this._processWriteQueue();
        });
    }

    /**
     * Process the write queue sequentially.
     */
    async _processWriteQueue() {
        if (this._writing || this._writeQueue.length === 0) return;
        this._writing = true;

        while (this._writeQueue.length > 0) {
            const { data, resolve, reject } = this._writeQueue.shift();

            // Throttle writes: minimum 50ms between writes
            const now = Date.now();
            const elapsed = now - this._lastWriteTime;
            if (elapsed < 50) {
                await new Promise(r => setTimeout(r, 50 - elapsed));
            }

            try {
                if (this._dataLogging) {
                    this._dataLog.push({
                        timestamp: Date.now(),
                        direction: 'tx',
                        data: Array.from(data)
                    });
                }

                if (this.writeChar.properties.writeWithoutResponse) {
                    await this.writeChar.writeValueWithoutResponse(data);
                } else {
                    await this.writeChar.writeValue(data);
                }
                this._lastWriteTime = Date.now();
                resolve();
            } catch (err) {
                reject(err);
            }
        }

        this._writing = false;
    }

    /**
     * Write a parameter to the controller.
     * @param {number} addr - Flash address
     * @param {number} value - uint16 value
     * @returns {Promise<void>}
     */
    async writeParameter(addr, value) {
        const cmd = this.protocol.writeParameter(addr, value);
        return this.write(cmd);
    }

    /**
     * Send a system command.
     * @param {number} cmd
     * @returns {Promise<void>}
     */
    async sendSystemCommand(cmd) {
        const data = this.protocol.sendSystemCommand(cmd);
        return this.write(data);
    }

    /**
     * Start auto-learn process.
     * @returns {Promise<void>}
     */
    async startAutoLearn() {
        const cmd = this.protocol.startAutoLearn();
        return this.write(cmd);
    }

    /**
     * Stop auto-learn process.
     * @returns {Promise<void>}
     */
    async stopAutoLearn() {
        const cmd = this.protocol.stopAutoLearn();
        return this.write(cmd);
    }

    /**
     * Reset controller to factory defaults.
     * @returns {Promise<void>}
     */
    async resetController() {
        const cmd = this.protocol.resetController();
        return this.write(cmd);
    }

    /**
     * Save parameters to flash.
     * @returns {Promise<void>}
     */
    async saveToFlash() {
        const cmd = this.protocol.saveToFlash();
        return this.write(cmd);
    }

    /**
     * Start polling - periodically send KeepAlive to maintain data flow.
     */
    startPolling() {
        this.stopPolling();
        this._pollCount = 0;
        this._pollTimer = setInterval(async () => {
            if (this.connected) {
                try {
                    this._pollCount++;
                    // Send Open command every 10th poll to refresh data stream
                    const cmd = (this._pollCount % 10 === 0)
                        ? this.protocol.requestCommand
                        : this.protocol.keepAliveCommand;
                    await this.write(cmd);
                } catch (e) {
                    console.warn('[BLE] Poll write failed:', e.message);
                }
            }
        }, 500);
    }

    /**
     * Stop polling.
     */
    stopPolling() {
        if (this._pollTimer) {
            clearInterval(this._pollTimer);
            this._pollTimer = null;
        }
    }

    /**
     * Start data logging.
     */
    startDataLogging() {
        this._dataLog = [];
        this._dataLogging = true;
    }

    /**
     * Stop data logging.
     * @returns {Array} The collected data log
     */
    stopDataLogging() {
        this._dataLogging = false;
        return [...this._dataLog];
    }

    /**
     * Get the current data log.
     * @returns {Array}
     */
    getDataLog() {
        return [...this._dataLog];
    }

    /**
     * Get protocol statistics.
     */
    get stats() {
        return this.protocol.stats;
    }

    /**
     * Get the current FardriverData.
     */
    get data() {
        return this.protocol.data;
    }
}
/**
 * Fardriver Tuner - Main Application Logic
 * Handles UI, tab switching, parameter management, charts, and i18n.
 */

// =============================================
//  i18n
// =============================================
const I18N = {
    en: {
        'status.disconnected': 'Disconnected',
        'status.connected': 'Connected',
        'status.connecting': 'Connecting...',
        'status.reconnecting': 'Reconnecting...',
        'btn.connect': 'Connect',
        'btn.disconnect': 'Disconnect',
        'btn.write': 'Write',
        'btn.writeAll': 'Write All',
        'btn.read': 'Read',
        'btn.save': 'Save to Flash',
        'btn.cancel': 'Cancel',
        'btn.confirm': 'Confirm',
        'btn.export': 'Export JSON',
        'btn.import': 'Import JSON',
        'btn.startAutoLearn': 'Start Auto-Learn',
        'btn.stopAutoLearn': 'Stop Auto-Learn',
        'btn.resetController': 'Reset Controller',
        'btn.startLogging': 'Start Logging',
        'btn.stopLogging': 'Stop Logging',
        'tab.dashboard': 'Dashboard',
        'tab.parameters': 'Parameters',
        'tab.currentLimit': 'Current Limit',
        'tab.functions': 'Functions',
        'tab.tools': 'Tools',
        'dash.speed': 'Speed',
        'dash.rpm': 'RPM',
        'dash.kmh': 'km/h',
        'dash.voltage': 'Voltage',
        'dash.current': 'Current',
        'dash.power': 'Power',
        'dash.gear': 'Gear',
        'dash.throttle': 'Throttle',
        'dash.brake': 'Brake',
        'dash.brakeOn': 'BRAKE ON',
        'dash.brakeOff': 'Brake Off',
        'dash.motorTemp': 'Motor Temp',
        'dash.ctrlTemp': 'Controller Temp',
        'dash.modulation': 'Modulation',
        'dash.errors': 'Protection / Errors',
        'dash.phaseA': 'Phase A Current',
        'dash.phaseC': 'Phase C Current',
        'dash.soc': 'Battery SOC',
        'chart.speed': 'Speed History',
        'chart.currentPower': 'Current / Power',
        'chart.temperature': 'Temperature',
        'chart.throttleMod': 'Throttle / Modulation',
        'section.motor': 'Motor',
        'section.current': 'Current Limits',
        'section.speed': 'Speed',
        'section.throttle': 'Throttle',
        'section.battery': 'Battery',
        'section.braking': 'Braking',
        'section.protection': 'Protection',
        'section.features': 'Features',
        'section.pins': 'Pins',
        'section.advanced': 'Advanced',
        'curve.lineCurrentTitle': 'Line Current Limit Curve',
        'curve.regenTitle': 'Regenerative Braking Curve',
        'curve.rpmLabel': 'RPM',
        'curve.percentLabel': '%',
        'func.pinAssignments': 'Pin Assignments',
        'func.featureToggles': 'Feature Toggles',
        'func.gearConfiguration': 'Gear Configuration',
        'tools.autoLearn': 'Auto-Learn',
        'tools.autoLearnDesc': 'Calibrate the motor position sensor. The motor will spin during this process.',
        'tools.autoLearnStep1': 'Suspend the rear wheel so it can spin freely',
        'tools.autoLearnStep2': 'Ensure the area is clear and safe',
        'tools.autoLearnStep3': 'Hold throttle wide open when prompted',
        'tools.autoLearnStep4': 'The motor will spin and calibrate automatically',
        'tools.autoLearnStep5': 'Do not interrupt the process',
        'tools.reset': 'Reset Controller',
        'tools.resetDesc': 'Restore all parameters to factory defaults. This cannot be undone.',
        'tools.exportImport': 'Export / Import',
        'tools.exportImportDesc': 'Save all parameters as a JSON file or restore from a previously saved file.',
        'tools.firmware': 'Firmware Info',
        'tools.dataCollection': 'Data Collection',
        'tools.dataCollectionDesc': 'Record raw BLE data for diagnostics and analysis.',
        'tools.totalRuntime': 'Total Runtime',
        'tools.totalDistance': 'Total Distance',
        'tools.hwVersion': 'Hardware Version',
        'tools.swVersion': 'Software Version',
        'tools.fwDate': 'Firmware Date',
        'tools.packetsRx': 'Packets Received',
        'tools.crcErrors': 'CRC Errors',
        'tools.errorRate': 'Error Rate',
        'confirm.write': 'Are you sure you want to write this parameter to the controller?',
        'confirm.writeAll': 'Are you sure you want to write all modified parameters to the controller?',
        'confirm.reset': 'WARNING: This will reset ALL parameters to factory defaults. Are you sure?',
        'confirm.autoLearn': 'The motor will spin during auto-learn. Make sure the wheel is suspended and the area is clear. Continue?',
        'toast.connected': 'Connected to controller',
        'toast.disconnected': 'Disconnected from controller',
        'toast.writeSuccess': 'Parameter written successfully',
        'toast.writeError': 'Failed to write parameter',
        'toast.exportSuccess': 'Parameters exported successfully',
        'toast.importSuccess': 'Parameters imported successfully',
        'toast.importError': 'Failed to import parameters',
        'toast.resetSuccess': 'Controller reset to factory defaults',
        'toast.autoLearnStarted': 'Auto-learn started',
        'toast.autoLearnStopped': 'Auto-learn stopped',
        'toast.bleNotSupported': 'Web Bluetooth is not supported in this browser',
        'toast.savedToFlash': 'Parameters saved to flash',
        'toast.noChanges': 'No changes to write'
    },
    fr: {
        'status.disconnected': 'Deconnecte',
        'status.connected': 'Connecte',
        'status.connecting': 'Connexion...',
        'status.reconnecting': 'Reconnexion...',
        'btn.connect': 'Connecter',
        'btn.disconnect': 'Deconnecter',
        'btn.write': 'Ecrire',
        'btn.writeAll': 'Ecrire tout',
        'btn.read': 'Lire',
        'btn.save': 'Sauver en flash',
        'btn.cancel': 'Annuler',
        'btn.confirm': 'Confirmer',
        'btn.export': 'Exporter JSON',
        'btn.import': 'Importer JSON',
        'btn.startAutoLearn': 'Demarrer Auto-Learn',
        'btn.stopAutoLearn': 'Arreter Auto-Learn',
        'btn.resetController': 'Reinitialiser',
        'btn.startLogging': 'Demarrer enreg.',
        'btn.stopLogging': 'Arreter enreg.',
        'tab.dashboard': 'Tableau de bord',
        'tab.parameters': 'Parametres',
        'tab.currentLimit': 'Limite courant',
        'tab.functions': 'Fonctions',
        'tab.tools': 'Outils',
        'dash.speed': 'Vitesse',
        'dash.rpm': 'RPM',
        'dash.kmh': 'km/h',
        'dash.voltage': 'Tension',
        'dash.current': 'Courant',
        'dash.power': 'Puissance',
        'dash.gear': 'Rapport',
        'dash.throttle': 'Accelerateur',
        'dash.brake': 'Frein',
        'dash.brakeOn': 'FREIN ACTIF',
        'dash.brakeOff': 'Frein Inactif',
        'dash.motorTemp': 'Temp Moteur',
        'dash.ctrlTemp': 'Temp Controleur',
        'dash.modulation': 'Modulation',
        'dash.errors': 'Protection / Erreurs',
        'dash.phaseA': 'Courant Phase A',
        'dash.phaseC': 'Courant Phase C',
        'dash.soc': 'SOC Batterie',
        'chart.speed': 'Historique Vitesse',
        'chart.currentPower': 'Courant / Puissance',
        'chart.temperature': 'Temperature',
        'chart.throttleMod': 'Accel. / Modulation',
        'section.motor': 'Moteur',
        'section.current': 'Limites de courant',
        'section.speed': 'Vitesse',
        'section.throttle': 'Accelerateur',
        'section.battery': 'Batterie',
        'section.braking': 'Freinage',
        'section.protection': 'Protection',
        'section.features': 'Fonctionnalites',
        'section.pins': 'Broches',
        'section.advanced': 'Avance',
        'curve.lineCurrentTitle': 'Courbe limite courant ligne',
        'curve.regenTitle': 'Courbe freinage regeneratif',
        'curve.rpmLabel': 'RPM',
        'curve.percentLabel': '%',
        'func.pinAssignments': 'Assignation des broches',
        'func.featureToggles': 'Fonctionnalites',
        'func.gearConfiguration': 'Configuration des rapports',
        'tools.autoLearn': 'Auto-Learn',
        'tools.autoLearnDesc': 'Calibrer le capteur de position moteur. Le moteur tournera pendant ce processus.',
        'tools.autoLearnStep1': 'Suspendre la roue arriere pour qu\'elle tourne librement',
        'tools.autoLearnStep2': 'S\'assurer que la zone est degagee et securitaire',
        'tools.autoLearnStep3': 'Maintenir l\'accelerateur a fond lorsque demande',
        'tools.autoLearnStep4': 'Le moteur tournera et se calibrera automatiquement',
        'tools.autoLearnStep5': 'Ne pas interrompre le processus',
        'tools.reset': 'Reinitialiser le controleur',
        'tools.resetDesc': 'Restaurer tous les parametres aux valeurs d\'usine. Irreversible.',
        'tools.exportImport': 'Exporter / Importer',
        'tools.exportImportDesc': 'Sauvegarder les parametres en JSON ou restaurer un fichier precedemment sauvegarde.',
        'tools.firmware': 'Info Firmware',
        'tools.dataCollection': 'Collecte de donnees',
        'tools.dataCollectionDesc': 'Enregistrer les donnees BLE brutes pour diagnostic et analyse.',
        'tools.totalRuntime': 'Duree totale',
        'tools.totalDistance': 'Distance totale',
        'tools.hwVersion': 'Version materiel',
        'tools.swVersion': 'Version logiciel',
        'tools.fwDate': 'Date firmware',
        'tools.packetsRx': 'Paquets recus',
        'tools.crcErrors': 'Erreurs CRC',
        'tools.errorRate': 'Taux d\'erreur',
        'confirm.write': 'Etes-vous sur de vouloir ecrire ce parametre au controleur ?',
        'confirm.writeAll': 'Etes-vous sur de vouloir ecrire tous les parametres modifies ?',
        'confirm.reset': 'ATTENTION : Ceci reinitialise TOUS les parametres aux valeurs d\'usine. Etes-vous sur ?',
        'confirm.autoLearn': 'Le moteur tournera pendant l\'auto-learn. Assurez-vous que la roue est suspendue et la zone est degagee. Continuer ?',
        'toast.connected': 'Connecte au controleur',
        'toast.disconnected': 'Deconnecte du controleur',
        'toast.writeSuccess': 'Parametre ecrit avec succes',
        'toast.writeError': 'Echec de l\'ecriture du parametre',
        'toast.exportSuccess': 'Parametres exportes avec succes',
        'toast.importSuccess': 'Parametres importes avec succes',
        'toast.importError': 'Echec de l\'import des parametres',
        'toast.resetSuccess': 'Controleur reinitialise aux valeurs d\'usine',
        'toast.autoLearnStarted': 'Auto-learn demarre',
        'toast.autoLearnStopped': 'Auto-learn arrete',
        'toast.bleNotSupported': 'Web Bluetooth n\'est pas supporte par ce navigateur',
        'toast.savedToFlash': 'Parametres sauves en flash',
        'toast.noChanges': 'Aucun changement a ecrire'
    }
};

let currentLang = 'en';

function t(key) {
    return (I18N[currentLang] && I18N[currentLang][key]) || I18N.en[key] || key;
}

function applyI18n() {
    document.querySelectorAll('[data-i18n]').forEach(el => {
        const key = el.getAttribute('data-i18n');
        const text = t(key);
        if (el.tagName === 'INPUT' && el.type !== 'checkbox') {
            el.placeholder = text;
        } else {
            el.textContent = text;
        }
    });
}

// =============================================
//  Chart Manager
// =============================================
class ChartManager {
    constructor() {
        this.charts = {};
        this.maxPoints = 120;
        this.labels = [];
    }

    init() {
        const commonOpts = {
            responsive: true,
            maintainAspectRatio: false,
            animation: false,
            plugins: {
                legend: { display: true, labels: { color: '#64748b', font: { size: 10 } } }
            },
            scales: {
                x: {
                    display: false,
                    grid: { display: false }
                },
                y: {
                    ticks: { color: '#64748b', font: { size: 10 } },
                    grid: { color: 'rgba(255,255,255,0.04)' }
                }
            }
        };

        const mkChart = (id, datasets, yLabel) => {
            const ctx = document.getElementById(id);
            if (!ctx) return null;
            return new Chart(ctx, {
                type: 'line',
                data: { labels: [], datasets },
                options: {
                    ...commonOpts,
                    scales: {
                        ...commonOpts.scales,
                        y: { ...commonOpts.scales.y, title: { display: true, text: yLabel, color: '#64748b' } }
                    }
                }
            });
        };

        this.charts.speed = mkChart('chartSpeed', [
            { label: 'RPM', data: [], borderColor: '#06b6d4', backgroundColor: 'rgba(6,182,212,0.1)', fill: true, tension: 0.3, pointRadius: 0, borderWidth: 1.5 }
        ], 'RPM');

        this.charts.currentPower = mkChart('chartCurrentPower', [
            { label: 'Current (A)', data: [], borderColor: '#3b82f6', tension: 0.3, pointRadius: 0, borderWidth: 1.5 },
            { label: 'Power (W)', data: [], borderColor: '#f97316', tension: 0.3, pointRadius: 0, borderWidth: 1.5, yAxisID: 'y1' }
        ], 'A');

        if (this.charts.currentPower) {
            this.charts.currentPower.options.scales.y1 = {
                position: 'right',
                ticks: { color: '#f97316', font: { size: 10 } },
                grid: { display: false },
                title: { display: true, text: 'W', color: '#f97316' }
            };
        }

        this.charts.temperature = mkChart('chartTemperature', [
            { label: 'Motor', data: [], borderColor: '#ef4444', tension: 0.3, pointRadius: 0, borderWidth: 1.5 },
            { label: 'Controller', data: [], borderColor: '#eab308', tension: 0.3, pointRadius: 0, borderWidth: 1.5 }
        ], '\u00B0C');

        this.charts.throttleMod = mkChart('chartThrottleMod', [
            { label: 'Throttle %', data: [], borderColor: '#22c55e', tension: 0.3, pointRadius: 0, borderWidth: 1.5 },
            { label: 'Modulation %', data: [], borderColor: '#a855f7', tension: 0.3, pointRadius: 0, borderWidth: 1.5 }
        ], '%');
    }

    update(data) {
        const now = new Date().toLocaleTimeString();

        for (const chart of Object.values(this.charts)) {
            if (!chart) continue;
            chart.data.labels.push(now);
            if (chart.data.labels.length > this.maxPoints) {
                chart.data.labels.shift();
            }
        }

        this._push(this.charts.speed, 0, data.measureSpeed);
        this._push(this.charts.currentPower, 0, data.lineCurrent);
        this._push(this.charts.currentPower, 1, data.power);
        this._push(this.charts.temperature, 0, data.motorTemp);
        if (data.controllerTemp != null) this._push(this.charts.temperature, 1, data.controllerTemp);

        const throttlePct = Math.min(100, Math.max(0, (data.throttleDepth / 255) * 100));
        this._push(this.charts.throttleMod, 0, throttlePct);
        this._push(this.charts.throttleMod, 1, data.modulation);

        for (const chart of Object.values(this.charts)) {
            if (chart) chart.update('none');
        }
    }

    _push(chart, dsIdx, value) {
        if (!chart || !chart.data.datasets[dsIdx]) return;
        chart.data.datasets[dsIdx].data.push(value);
        if (chart.data.datasets[dsIdx].data.length > this.maxPoints) {
            chart.data.datasets[dsIdx].data.shift();
        }
    }

    destroy() {
        for (const chart of Object.values(this.charts)) {
            if (chart) chart.destroy();
        }
        this.charts = {};
    }
}

// =============================================
//  Current Curve Editor
// =============================================
class CurveEditor {
    constructor(canvasId, pointsInputContainerId, data, tableKey) {
        this.canvasId = canvasId;
        this.containerId = pointsInputContainerId;
        this.data = data;
        this.tableKey = tableKey;
        this.chart = null;
        this.isDragging = false;
        this.dragIndex = -1;
    }

    init() {
        const ctx = document.getElementById(this.canvasId);
        if (!ctx) return;

        const values = this.data[this.tableKey];

        this.chart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: CURRENT_CURVE_RPM.map(r => r.toString()),
                datasets: [{
                    label: this.tableKey.includes('regen') ? 'Regen %' : 'Current %',
                    data: [...values],
                    borderColor: this.tableKey.includes('regen') ? '#ef4444' : '#06b6d4',
                    backgroundColor: this.tableKey.includes('regen') ? 'rgba(239,68,68,0.1)' : 'rgba(6,182,212,0.1)',
                    fill: true,
                    tension: 0.2,
                    pointRadius: 6,
                    pointHoverRadius: 10,
                    pointBackgroundColor: this.tableKey.includes('regen') ? '#ef4444' : '#06b6d4',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2,
                    borderWidth: 2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                animation: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => `${CURRENT_CURVE_RPM[ctx.dataIndex]} RPM: ${ctx.parsed.y}%`
                        }
                    }
                },
                scales: {
                    x: {
                        title: { display: true, text: 'RPM', color: '#64748b' },
                        ticks: { color: '#64748b', font: { size: 10 } },
                        grid: { color: 'rgba(255,255,255,0.04)' }
                    },
                    y: {
                        min: 0,
                        max: 120,
                        title: { display: true, text: '%', color: '#64748b' },
                        ticks: { color: '#64748b', font: { size: 10 } },
                        grid: { color: 'rgba(255,255,255,0.04)' }
                    }
                },
                onHover: (event, elements) => {
                    ctx.style.cursor = elements.length > 0 ? 'grab' : 'default';
                }
            }
        });

        // Drag support
        ctx.addEventListener('mousedown', (e) => this._onMouseDown(e));
        ctx.addEventListener('mousemove', (e) => this._onMouseMove(e));
        ctx.addEventListener('mouseup', () => this._onMouseUp());
        ctx.addEventListener('mouseleave', () => this._onMouseUp());

        // Touch support
        ctx.addEventListener('touchstart', (e) => {
            e.preventDefault();
            const touch = e.touches[0];
            this._onMouseDown({ ...touch, target: ctx });
        });
        ctx.addEventListener('touchmove', (e) => {
            e.preventDefault();
            const touch = e.touches[0];
            this._onMouseMove({ ...touch, target: ctx });
        });
        ctx.addEventListener('touchend', () => this._onMouseUp());

        // Build point inputs
        this._buildInputs();
    }

    _buildInputs() {
        const container = document.getElementById(this.containerId);
        if (!container) return;
        container.innerHTML = '';

        const values = this.data[this.tableKey];
        CURRENT_CURVE_RPM.forEach((rpm, i) => {
            const div = document.createElement('div');
            div.className = 'curve-point';
            div.innerHTML = `
                <label>${rpm} RPM</label>
                <input type="number" min="0" max="120" value="${values[i]}"
                       data-curve-idx="${i}" class="curve-input">
            `;
            container.appendChild(div);

            div.querySelector('input').addEventListener('change', (e) => {
                const val = Math.max(0, Math.min(120, parseInt(e.target.value) || 0));
                e.target.value = val;
                this.data[this.tableKey][i] = val;
                this.chart.data.datasets[0].data[i] = val;
                this.chart.update('none');
            });
        });
    }

    _onMouseDown(e) {
        const points = this.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
        if (points.length > 0) {
            this.isDragging = true;
            this.dragIndex = points[0].index;
        }
    }

    _onMouseMove(e) {
        if (!this.isDragging || this.dragIndex < 0) return;

        const rect = e.target.getBoundingClientRect();
        const y = e.clientY - rect.top;
        const yScale = this.chart.scales.y;
        let value = Math.round(yScale.getValueForPixel(y));
        value = Math.max(0, Math.min(120, value));

        this.data[this.tableKey][this.dragIndex] = value;
        this.chart.data.datasets[0].data[this.dragIndex] = value;
        this.chart.update('none');

        // Update input
        const container = document.getElementById(this.containerId);
        if (container) {
            const input = container.querySelector(`[data-curve-idx="${this.dragIndex}"]`);
            if (input) input.value = value;
        }
    }

    _onMouseUp() {
        this.isDragging = false;
        this.dragIndex = -1;
    }

    updateFromData() {
        if (!this.chart) return;
        const values = this.data[this.tableKey];
        this.chart.data.datasets[0].data = [...values];
        this.chart.update('none');
        this._buildInputs();
    }

    getValues() {
        return [...this.data[this.tableKey]];
    }
}


// =============================================
//  Main Application
// =============================================
class FardriverApp {
    constructor() {
        this.ble = new FardriverBLE();
        this.charts = new ChartManager();
        this.curveEditors = {};
        this.pendingChanges = {};
        this._updateInterval = null;
        this._autoLearnActive = false;
        this._dataLogging = false;
        this._logger = (window.VOLTALIZE_LOG_ENDPOINT && window.VotalizeLogger) ? new window.VotalizeLogger(window.VOLTALIZE_LOG_ENDPOINT) : null;

        this._bindEvents();
    }

    init() {
        applyI18n();
        this.charts.init();
        this._initCurveEditors();
        this._initAccordions();
        this._buildParameterForms();
        this._updateConnectionUI(false);

        // Start UI update loop
        this._updateInterval = setInterval(() => this._updateDashboard(), 200);
    }

    _bindEvents() {
        // Connection
        document.getElementById('btnConnect')?.addEventListener('click', () => this.connect());
        document.getElementById('btnDisconnect')?.addEventListener('click', () => this.disconnect());

        // Menu toggle
        document.getElementById('btnMenuToggle')?.addEventListener('click', () => {
            document.getElementById('headerActions')?.classList.toggle('show');
        });

        // Language
        document.getElementById('selectLang')?.addEventListener('change', (e) => {
            currentLang = e.target.value;
            applyI18n();
        });

        // Tabs
        document.querySelectorAll('.tab-btn').forEach(btn => {
            btn.addEventListener('click', () => this._switchTab(btn.dataset.tab));
        });

        // Tools buttons
        document.getElementById('btnAutoLearn')?.addEventListener('click', () => this._startAutoLearn());
        document.getElementById('btnStopAutoLearn')?.addEventListener('click', () => this._stopAutoLearn());
        document.getElementById('btnResetController')?.addEventListener('click', () => this._resetController());
        document.getElementById('btnExport')?.addEventListener('click', () => this._exportParams());
        document.getElementById('btnImport')?.addEventListener('click', () => this._importParams());
        document.getElementById('btnStartLogging')?.addEventListener('click', () => this._startLogging());
        document.getElementById('btnStopLogging')?.addEventListener('click', () => this._stopLogging());
        document.getElementById('btnSaveCurves')?.addEventListener('click', () => this._saveCurves());

        // Modal
        document.getElementById('btnModalCancel')?.addEventListener('click', () => this._hideModal());
        document.getElementById('btnModalConfirm')?.addEventListener('click', () => {
            if (this._modalCallback) this._modalCallback();
            this._hideModal();
        });

        // BLE events
        this.ble.addEventListener('connected', () => {
            this._updateConnectionUI(true);
            this._showToast(t('toast.connected'), 'success');
            if (this._logger) { this._logger.logConnection('fardriver-tuner', 'connected', this.ble.deviceName, 'Fardriver', currentLang); }
        });

        this.ble.addEventListener('disconnected', () => {
            this._updateConnectionUI(false);
            this._showToast(t('toast.disconnected'), 'warning');
            if (this._logger) { this._logger.logConnection('fardriver-tuner', 'disconnected', this.ble.deviceName, 'Fardriver', currentLang); this._logger.reset(); }
        });

        this.ble.addEventListener('reconnecting', (e) => {
            const status = document.getElementById('connectionStatus');
            if (status) {
                status.textContent = t('status.reconnecting');
                status.className = 'status-badge status-connecting';
            }
        });

        this.ble.addEventListener('data', (e) => {
            // Charts update at lower frequency
            this.charts.update(e.detail);
        });

        // File import input
        document.getElementById('fileImport')?.addEventListener('change', (e) => this._handleFileImport(e));
    }

    // ---- Connection ----

    async connect() {
        try {
            const status = document.getElementById('connectionStatus');
            if (status) {
                status.textContent = t('status.connecting');
                status.className = 'status-badge status-connecting';
            }

            await this.ble.scan();
            await this.ble.connect();
        } catch (err) {
            console.error('Connect error:', err);
            this._updateConnectionUI(false);
            if (err.i18nKey === 'bleNotSupported') {
                this._showToast(t('toast.bleNotSupported'), 'error');
            } else if (err.message !== 'User cancelled the requestDevice() chooser.') {
                this._showToast(err.message, 'error');
            }
        }
    }

    async disconnect() {
        await this.ble.disconnect();
    }

    _updateConnectionUI(connected) {
        const status = document.getElementById('connectionStatus');
        const btnConnect = document.getElementById('btnConnect');
        const btnDisconnect = document.getElementById('btnDisconnect');
        const deviceNameEl = document.getElementById('deviceName');

        if (status) {
            status.textContent = connected ? t('status.connected') : t('status.disconnected');
            status.className = `status-badge ${connected ? 'status-connected' : 'status-disconnected'}`;
        }
        if (btnConnect) btnConnect.classList.toggle('hidden', connected);
        if (btnDisconnect) btnDisconnect.classList.toggle('hidden', !connected);
        if (deviceNameEl) deviceNameEl.textContent = connected ? this.ble.deviceName : '--';
    }

    // ---- Tabs ----

    _switchTab(tabId) {
        document.querySelectorAll('.tab-btn').forEach(b => b.classList.toggle('active', b.dataset.tab === tabId));
        document.querySelectorAll('.tab-panel').forEach(p => p.classList.toggle('active', p.id === `panel-${tabId}`));

        // Trigger chart resize if switching to dashboard
        if (tabId === 'dashboard') {
            setTimeout(() => {
                for (const chart of Object.values(this.charts.charts)) {
                    if (chart) chart.resize();
                }
            }, 50);
        }

        // Update curve editors when switching to that tab
        if (tabId === 'currentLimit') {
            Object.values(this.curveEditors).forEach(e => e.updateFromData());
        }
    }

    // ---- Dashboard ----

    _updateDashboard() {
        const data = this.ble.data;
        if (!data) return;

        // Send config snapshot once when flash config is fully loaded
        if (this._logger && data.configLoaded && this.ble.deviceName) {
            this._logger.logConfig('fardriver-tuner', this.ble.deviceName, data.exportConfig());
        }

        // Speed
        this._setText('valRPM', data.measureSpeed);
        const kmh = this._rpmToKmh(data.measureSpeed);
        this._setText('valKmh', kmh.toFixed(1));

        // Voltage, Current, Power
        this._setText('valVoltage', data.voltage.toFixed(1));
        this._setText('valCurrent', data.lineCurrent.toFixed(1));
        this._setText('valPower', Math.round(data.power));

        // Gear
        this._updateGear(data);

        // Throttle
        const throttlePct = Math.min(100, Math.max(0, (data.throttleDepth / 255) * 100));
        this._setText('valThrottle', throttlePct.toFixed(0) + '%');
        const throttleFill = document.getElementById('throttleFill');
        if (throttleFill) throttleFill.style.width = throttlePct + '%';
        const throttleLabel = document.getElementById('throttleLabel');
        if (throttleLabel) throttleLabel.textContent = throttlePct.toFixed(0) + '%';

        // Brake
        const brakeEl = document.getElementById('brakeIndicator');
        if (brakeEl) {
            brakeEl.className = `brake-indicator ${data.brake ? 'brake-on' : 'brake-off'}`;
            brakeEl.textContent = data.brake ? t('dash.brakeOn') : t('dash.brakeOff');
        }

        // Temperatures
        this._setText('valMotorTemp', data.motorTemp);
        this._setText('valCtrlTemp', data.controllerTemp ?? '--');
        this._setTempColor('valMotorTemp', data.motorTemp);
        if (data.controllerTemp != null) this._setTempColor('valCtrlTemp', data.controllerTemp);

        // Modulation
        this._setText('valModulation', (data.modulation * 100).toFixed(1));

        // Phase currents
        this._setText('valPhaseA', data.phaseACurrent.toFixed(1));
        this._setText('valPhaseC', data.phaseCCurrent.toFixed(1));

        // SOC
        this._setText('valSOC', data.batterySOC);

        // Error flags
        this._updateErrorFlags(data);

        // Stats
        const stats = this.ble.stats;
        this._setText('valPacketsRx', stats.packetCount);
        this._setText('valCrcErrors', stats.crcErrors);

        // Firmware info (tools tab)
        this._setText('valHwVersion', data.hardwareVersion || '--');
        this._setText('valSwVersion', data.softwareVersion || '--');
        this._setText('valFwDate', data.firmwareYear ? `${data.firmwareYear}/${data.firmwareMonth}/${data.firmwareDay}` : '--');
        this._setText('valTotalTime', data.totalTime ? this._formatDuration(data.totalTime) : '--');
        this._setText('valTotalDistance', data.distance ? `${(data.distance / 1000).toFixed(1)} km` : '--');

        // Update parameter current values (if params tab visible)
        if (document.getElementById('panel-parameters')?.classList.contains('active')) {
            this._updateParamDisplayValues();
        }

        // Update functions tab if visible
        if (document.getElementById('panel-functions')?.classList.contains('active')) {
            this._updateFunctionsTab(data);
        }
    }

    _updateFunctionsTab(data) {
        // Pin assignments
        const pinFields = {
            funcPausePin: data.pausePin,
            funcSideStandPin: data.sideStandPin,
            funcCruisePin: data.cruisePin,
            funcBoostPin: data.boostPin,
            funcLowSpeedPin: data.lowSpeedPin,
            funcHighSpeedPin: data.highSpeedPin,
            funcReversePin: data.reversePin,
            funcForwardPin: data.forwardPin,
            funcSwitchVolPin: data.switchVolPin,
            funcSeatPin: data.seatPin,
            funcAntiTheftPin: data.antiTheftPin,
            funcChargePin: data.chargePin
        };

        for (const [id, val] of Object.entries(pinFields)) {
            const el = document.getElementById(id);
            if (el) el.textContent = PIN_OPTIONS[val] || `Pin ${val}`;
        }

        // Feature toggles (read-only display)
        const featureMap = {
            funcCruise: data.cruiseEnable,
            funcEabs: data.eabsEnable,
            funcPush: data.pushEnable,
            funcPGear: data.pEnable,
            funcSeat: data.seatEnable,
            funcAntiTheft: data.forceAntiTheft,
            funcOverSpeed: data.overSpeedAlarm,
            funcBrakePark: data.brakeStillPark,
            funcRemGear: data.rememberGear,
            funcReverse: data.backEnable
        };

        for (const [id, val] of Object.entries(featureMap)) {
            const el = document.getElementById(id);
            if (el) el.classList.toggle('active', !!val);
        }

        // Gear configuration
        this._setText('gearD1Speed', data.lowSpeed ? `${data.lowSpeed} RPM` : '-- RPM');
        this._setText('gearD2Speed', data.midSpeed ? `${data.midSpeed} RPM` : '-- RPM');
        this._setText('gearD3Speed', data.maxSpeed ? `${data.maxSpeed} RPM` : '-- RPM');
        this._setText('gearRSpeed', data.backSpeed ? `${data.backSpeed} RPM` : '-- RPM');
    }

    _rpmToKmh(rpm) {
        // Approximate: depends on wheel diameter and gear ratio
        // Using common e-bike/scooter: wheel circumference ~1.8m, gear ratio from controller
        const wheelCircumference = 1.8; // meters (adjustable)
        const gearRatio = this.ble.data.fwReRatio || 1;
        if (gearRatio === 0) return 0;
        return (rpm / gearRatio) * wheelCircumference * 60 / 1000;
    }

    _updateGear(data) {
        const badges = document.querySelectorAll('.gear-badge');
        badges.forEach(b => {
            b.className = 'gear-badge';
            const g = b.dataset.gear;
            if (g === data.gearName) {
                if (g === 'R') b.classList.add('active-r');
                else if (g === 'N') b.classList.add('active-n');
                else b.classList.add('active-d');
            }
        });
    }

    _updateErrorFlags(data) {
        const flags = {
            'flagHall': data.hallError,
            'flagThrottle': data.throttleError,
            'flagVoltage': data.voltageProtect,
            'flagTemp': data.tempProtect,
            'flagMosfet': data.mosfetCheck,
            'flagOvercurrent': data.overcurrent
        };

        for (const [id, active] of Object.entries(flags)) {
            const el = document.getElementById(id);
            if (el) {
                el.className = `error-flag ${active ? 'active' : 'ok'}`;
            }
        }
    }

    _setTempColor(id, temp) {
        const el = document.getElementById(id);
        if (!el) return;
        if (temp > 80) el.style.color = 'var(--red)';
        else if (temp > 60) el.style.color = 'var(--orange)';
        else if (temp > 40) el.style.color = 'var(--yellow)';
        else el.style.color = 'var(--green)';
    }

    _setText(id, value) {
        const el = document.getElementById(id);
        if (el) el.textContent = value;
    }

    _formatDuration(minutes) {
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        if (h > 24) {
            const d = Math.floor(h / 24);
            return `${d}d ${h % 24}h`;
        }
        return `${h}h ${m}m`;
    }

    // ---- Parameters ----

    _buildParameterForms() {
        for (const [sectionKey, sectionInfo] of Object.entries(PARAM_SECTIONS)) {
            const bodyEl = document.getElementById(`params-${sectionKey}`);
            if (!bodyEl) continue;

            const grid = document.createElement('div');
            grid.className = 'param-grid';

            // Filter params for this section
            const sectionParams = Object.entries(PARAM_MAP).filter(([_, p]) => p.section === sectionKey);

            for (const [paramKey, paramDef] of sectionParams) {
                const field = this._createParamField(paramKey, paramDef);
                grid.appendChild(field);
            }

            bodyEl.appendChild(grid);

            // Section-level write all button
            if (sectionParams.some(([_, p]) => p.type !== 'readonly')) {
                const actions = document.createElement('div');
                actions.className = 'accordion-actions';
                actions.innerHTML = `
                    <button class="btn btn-sm btn-ghost btn-section-read" data-section="${sectionKey}" data-i18n="btn.read">${t('btn.read')}</button>
                    <button class="btn btn-sm btn-primary btn-section-write" data-section="${sectionKey}" data-i18n="btn.writeAll">${t('btn.writeAll')}</button>
                `;
                bodyEl.appendChild(actions);

                actions.querySelector('.btn-section-write').addEventListener('click', () => this._writeSection(sectionKey));
            }
        }
    }

    _createParamField(paramKey, paramDef) {
        const field = document.createElement('div');
        field.className = 'param-field';
        field.id = `field-${paramKey}`;

        const label = document.createElement('div');
        label.className = 'param-label';
        label.innerHTML = `<span>${paramDef.label}</span>`;
        if (paramDef.unit) {
            label.innerHTML += `<span class="param-unit">(${paramDef.unit})</span>`;
        }
        field.appendChild(label);

        const inputGroup = document.createElement('div');
        inputGroup.className = 'param-input-group';

        if (paramDef.type === 'toggle') {
            const container = document.createElement('div');
            container.className = 'toggle-container';
            const toggle = document.createElement('div');
            toggle.className = 'toggle-switch';
            toggle.id = `input-${paramKey}`;
            toggle.dataset.param = paramKey;
            toggle.addEventListener('click', () => {
                if (paramDef.type === 'readonly') return;
                toggle.classList.toggle('active');
                toggle.classList.add('changed');
                this.pendingChanges[paramKey] = toggle.classList.contains('active');
                this._updatePendingIndicator();
            });
            container.appendChild(toggle);

            const writeBtn = document.createElement('button');
            writeBtn.className = 'btn-write';
            writeBtn.textContent = t('btn.write');
            writeBtn.addEventListener('click', () => this._writeParam(paramKey));
            container.appendChild(writeBtn);

            inputGroup.appendChild(container);
        } else if (paramDef.type === 'dropdown') {
            const select = document.createElement('select');
            select.className = 'param-input';
            select.id = `input-${paramKey}`;
            select.dataset.param = paramKey;

            for (const [val, text] of Object.entries(paramDef.options)) {
                const opt = document.createElement('option');
                opt.value = val;
                opt.textContent = text;
                select.appendChild(opt);
            }

            select.addEventListener('change', () => {
                select.classList.add('param-input-changed');
                this.pendingChanges[paramKey] = parseInt(select.value);
                this._updatePendingIndicator();
            });

            inputGroup.appendChild(select);

            const writeBtn = document.createElement('button');
            writeBtn.className = 'btn-write';
            writeBtn.textContent = t('btn.write');
            writeBtn.addEventListener('click', () => this._writeParam(paramKey));
            inputGroup.appendChild(writeBtn);
        } else if (paramDef.type === 'readonly') {
            const input = document.createElement('input');
            input.type = 'text';
            input.className = 'param-input';
            input.id = `input-${paramKey}`;
            input.readOnly = true;
            inputGroup.appendChild(input);
        } else {
            // number
            const input = document.createElement('input');
            input.type = 'number';
            input.className = 'param-input';
            input.id = `input-${paramKey}`;
            input.dataset.param = paramKey;
            if (paramDef.min !== undefined) input.min = paramDef.min;
            if (paramDef.max !== undefined) input.max = paramDef.max;

            input.addEventListener('change', () => {
                input.classList.add('param-input-changed');
                let val = parseInt(input.value) || 0;
                // Reverse the display divisor to get raw value
                if (paramDef.divisor) {
                    val = Math.round(val * paramDef.divisor);
                }
                this.pendingChanges[paramKey] = val;
                this._updatePendingIndicator();
            });

            inputGroup.appendChild(input);

            const writeBtn = document.createElement('button');
            writeBtn.className = 'btn-write';
            writeBtn.textContent = t('btn.write');
            writeBtn.addEventListener('click', () => this._writeParam(paramKey));
            inputGroup.appendChild(writeBtn);
        }

        field.appendChild(inputGroup);
        return field;
    }

    _updateParamDisplayValues() {
        const data = this.ble.data;
        if (!data) return;

        for (const [paramKey, paramDef] of Object.entries(PARAM_MAP)) {
            const el = document.getElementById(`input-${paramKey}`);
            if (!el) continue;
            // Don't overwrite if user has pending changes
            if (this.pendingChanges[paramKey] !== undefined) continue;

            let value = data[paramKey];
            if (value === undefined) continue;

            if (paramDef.type === 'toggle') {
                el.classList.toggle('active', !!value);
            } else if (paramDef.type === 'dropdown') {
                el.value = value;
            } else {
                if (paramDef.divisor) {
                    value = value / paramDef.divisor;
                }
                el.value = value;
            }
        }
    }

    _updatePendingIndicator() {
        const indicator = document.getElementById('changesPending');
        if (indicator) {
            const count = Object.keys(this.pendingChanges).length;
            indicator.classList.toggle('hidden', count === 0);
            const countEl = document.getElementById('pendingCount');
            if (countEl) countEl.textContent = count;
        }
    }

    async _writeParam(paramKey) {
        const paramDef = PARAM_MAP[paramKey];
        if (!paramDef || paramDef.type === 'readonly') return;

        if (!this.ble.connected) {
            this._showToast('Not connected', 'error');
            return;
        }

        this._showModal(t('confirm.write'), async () => {
            try {
                let value;
                if (this.pendingChanges[paramKey] !== undefined) {
                    value = this.pendingChanges[paramKey];
                } else {
                    value = this.ble.data[paramKey];
                }

                if (paramDef.type === 'toggle') {
                    value = value ? 1 : 0;
                }

                // Handle sub-byte fields
                if (paramDef.mask !== undefined || paramDef.shift !== undefined || paramDef.bit !== undefined) {
                    // Read current flash value, modify the relevant bits
                    let currentVal = this.ble.data._flash[paramDef.addr] || 0;

                    if (paramDef.bit !== undefined) {
                        // Toggle bit
                        if (value) {
                            currentVal |= (1 << paramDef.bit);
                        } else {
                            currentVal &= ~(1 << paramDef.bit);
                        }
                        value = currentVal;
                    } else if (paramDef.shift && paramDef.mask) {
                        currentVal &= ~(paramDef.mask << paramDef.shift);
                        currentVal |= ((value & paramDef.mask) << paramDef.shift);
                        value = currentVal;
                    } else if (paramDef.mask) {
                        currentVal &= ~paramDef.mask;
                        currentVal |= (value & paramDef.mask);
                        value = currentVal;
                    }
                }

                await this.ble.writeParameter(paramDef.addr, value & 0xFFFF);
                await this.ble.saveToFlash();

                // Clear change state
                delete this.pendingChanges[paramKey];
                const el = document.getElementById(`input-${paramKey}`);
                if (el) {
                    el.classList.remove('param-input-changed');
                    el.classList.remove('changed');
                }
                this._updatePendingIndicator();

                this._showToast(t('toast.writeSuccess'), 'success');
            } catch (err) {
                console.error('Write error:', err);
                this._showToast(t('toast.writeError') + ': ' + err.message, 'error');
            }
        });
    }

    async _writeSection(sectionKey) {
        const sectionParams = Object.entries(PARAM_MAP)
            .filter(([key, p]) => p.section === sectionKey && this.pendingChanges[key] !== undefined);

        if (sectionParams.length === 0) {
            this._showToast(t('toast.noChanges'), 'info');
            return;
        }

        this._showModal(t('confirm.writeAll'), async () => {
            for (const [paramKey] of sectionParams) {
                try {
                    const paramDef = PARAM_MAP[paramKey];
                    let value = this.pendingChanges[paramKey];

                    if (paramDef.type === 'toggle') {
                        value = value ? 1 : 0;
                    }

                    if (paramDef.bit !== undefined) {
                        let currentVal = this.ble.data._flash[paramDef.addr] || 0;
                        if (value) currentVal |= (1 << paramDef.bit);
                        else currentVal &= ~(1 << paramDef.bit);
                        value = currentVal;
                    } else if (paramDef.shift && paramDef.mask) {
                        let currentVal = this.ble.data._flash[paramDef.addr] || 0;
                        currentVal &= ~(paramDef.mask << paramDef.shift);
                        currentVal |= ((value & paramDef.mask) << paramDef.shift);
                        value = currentVal;
                    } else if (paramDef.mask) {
                        let currentVal = this.ble.data._flash[paramDef.addr] || 0;
                        currentVal &= ~paramDef.mask;
                        currentVal |= (value & paramDef.mask);
                        value = currentVal;
                    }

                    await this.ble.writeParameter(paramDef.addr, value & 0xFFFF);
                    delete this.pendingChanges[paramKey];
                    const el = document.getElementById(`input-${paramKey}`);
                    if (el) {
                        el.classList.remove('param-input-changed');
                        el.classList.remove('changed');
                    }

                    // Small delay between writes
                    await new Promise(r => setTimeout(r, 50));
                } catch (err) {
                    console.error(`Failed to write ${paramKey}:`, err);
                }
            }

            await this.ble.saveToFlash();
            this._updatePendingIndicator();
            this._showToast(t('toast.writeSuccess'), 'success');
        });
    }

    // ---- Accordions ----

    _initAccordions() {
        document.querySelectorAll('.accordion-header').forEach(header => {
            header.addEventListener('click', () => {
                const section = header.closest('.accordion-section');
                section.classList.toggle('open');
            });
        });
    }

    // ---- Curve Editors ----

    _initCurveEditors() {
        this.curveEditors.lineCurrent = new CurveEditor(
            'chartLineCurve', 'lineCurveInputs',
            this.ble.data, 'currentRatioTable1'
        );
        this.curveEditors.lineCurrent.init();

        this.curveEditors.regen = new CurveEditor(
            'chartRegenCurve', 'regenCurveInputs',
            this.ble.data, 'regenRatioTable'
        );
        this.curveEditors.regen.init();
    }

    async _saveCurves() {
        if (!this.ble.connected) {
            this._showToast('Not connected', 'error');
            return;
        }

        this._showModal(t('confirm.writeAll'), async () => {
            try {
                // Write current ratio table 1
                const table1 = this.curveEditors.lineCurrent.getValues();
                for (let i = 0; i < 18; i++) {
                    await this.ble.writeParameter(0x8E + i, table1[i]);
                    await new Promise(r => setTimeout(r, 30));
                }

                // Write regen table
                const regenTable = this.curveEditors.regen.getValues();
                for (let i = 0; i < 18; i++) {
                    await this.ble.writeParameter(0xB8 + i, regenTable[i]);
                    await new Promise(r => setTimeout(r, 30));
                }

                await this.ble.saveToFlash();
                this._showToast(t('toast.savedToFlash'), 'success');
            } catch (err) {
                this._showToast(t('toast.writeError') + ': ' + err.message, 'error');
            }
        });
    }

    // ---- Tools ----

    _startAutoLearn() {
        this._showModal(t('confirm.autoLearn'), async () => {
            try {
                await this.ble.startAutoLearn();
                this._autoLearnActive = true;
                document.getElementById('btnAutoLearn')?.classList.add('hidden');
                document.getElementById('btnStopAutoLearn')?.classList.remove('hidden');
                this._showToast(t('toast.autoLearnStarted'), 'success');
            } catch (err) {
                this._showToast(err.message, 'error');
            }
        });
    }

    async _stopAutoLearn() {
        try {
            await this.ble.stopAutoLearn();
            this._autoLearnActive = false;
            document.getElementById('btnAutoLearn')?.classList.remove('hidden');
            document.getElementById('btnStopAutoLearn')?.classList.add('hidden');
            this._showToast(t('toast.autoLearnStopped'), 'info');
        } catch (err) {
            this._showToast(err.message, 'error');
        }
    }

    _resetController() {
        this._showModal(t('confirm.reset'), async () => {
            try {
                await this.ble.resetController();
                this._showToast(t('toast.resetSuccess'), 'success');
            } catch (err) {
                this._showToast(err.message, 'error');
            }
        });
    }

    _exportParams() {
        const data = this.ble.data;
        const config = data.exportConfig();
        const json = JSON.stringify(config, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `fardriver-config-${new Date().toISOString().slice(0, 10)}.json`;
        a.click();
        URL.revokeObjectURL(url);
        this._showToast(t('toast.exportSuccess'), 'success');
    }

    _importParams() {
        document.getElementById('fileImport')?.click();
    }

    _handleFileImport(event) {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const config = JSON.parse(e.target.result);
                this.ble.data.importConfig(config);
                this._updateParamDisplayValues();
                // Mark all as pending changes
                for (const section of Object.values(config)) {
                    if (typeof section === 'object' && section !== null && !Array.isArray(section)) {
                        for (const [key, val] of Object.entries(section)) {
                            if (PARAM_MAP[key]) {
                                this.pendingChanges[key] = val;
                            }
                        }
                    }
                }
                this._updatePendingIndicator();
                this._showToast(t('toast.importSuccess'), 'success');
            } catch (err) {
                this._showToast(t('toast.importError') + ': ' + err.message, 'error');
            }
        };
        reader.readAsText(file);
        event.target.value = ''; // Reset
    }

    _startLogging() {
        this.ble.startDataLogging();
        this._dataLogging = true;
        document.getElementById('btnStartLogging')?.classList.add('hidden');
        document.getElementById('btnStopLogging')?.classList.remove('hidden');
        document.getElementById('loggingStatus')?.classList.remove('hidden');
    }

    _stopLogging() {
        const log = this.ble.stopDataLogging();
        this._dataLogging = false;
        document.getElementById('btnStartLogging')?.classList.remove('hidden');
        document.getElementById('btnStopLogging')?.classList.add('hidden');
        document.getElementById('loggingStatus')?.classList.add('hidden');

        // Download log
        const json = JSON.stringify(log, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `fardriver-log-${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.json`;
        a.click();
        URL.revokeObjectURL(url);
    }

    // ---- Modal ----

    _showModal(message, onConfirm) {
        this._modalCallback = onConfirm;
        const overlay = document.getElementById('modalOverlay');
        const body = document.getElementById('modalBody');
        if (overlay && body) {
            body.textContent = message;
            overlay.classList.remove('hidden');
        }
    }

    _hideModal() {
        const overlay = document.getElementById('modalOverlay');
        if (overlay) overlay.classList.add('hidden');
        this._modalCallback = null;
    }

    // ---- Toast ----

    _showToast(message, type = 'info') {
        const container = document.getElementById('toastContainer');
        if (!container) return;

        const toast = document.createElement('div');
        toast.className = `toast toast-${type}`;
        toast.textContent = message;
        container.appendChild(toast);

        setTimeout(() => {
            toast.style.opacity = '0';
            toast.style.transform = 'translateX(100%)';
            toast.style.transition = 'all 0.3s';
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }
}


// =============================================
//  Initialize
// =============================================
document.addEventListener('DOMContentLoaded', () => {
    const app = new FardriverApp();
    app.init();
    window.fardriverApp = app; // Debug access
});

})();
